import { formatMoneyIn, invoiceIngredientKey, conAvisoVisto, conTareaHecha, SETUP_LAST_STEP, NOVEDADES_ID, teniaCuentaAntesDeNovedades, type EmpiezaPor } from '@alexiarest/shared';
import { diasQueQuedanDePrueba, fasePrueba, fechaEnZona, mensajeSinPlan, normalizarTaxId, recomendarPlan, revenueOf, sinPlanActivo, TRIAL_DAYS, validarTaxId, zonaDeLaPrueba, type ResumenPrueba, type TaxProfile } from '@alexiarest/shared';
import {
  aceptacionesDe,
  conFlujoDeRetencion,
  finDePausa,
  mrrDeTenant,
  ofertaParaMotivo,
  ofertaReciente,
  sinOfertaDeRetencionPor,
  vistaDeOfertaDeRetencion,
  type OfertaRetencion,
} from '@alexiarest/shared';
// Bloque C (Configuración y varios locales, 14 oct 2026): espejo de la API.
import { seatLimitFor, usageStatus, confirmaNombre, diasQueAbre, direccionPropuesta, enAmbito, esTodoElGrupo, fechaDeBorrado, gastosDeLocales, leerAmbito, localesQueVe, locationLimitOf, type Location as LocalDemo } from '@alexiarest/shared';
import { aplicarEdicionProveedor, taxIdComparable, nuevoProveedor, proveedorUnido, supplierInputSchema } from '@alexiarest/shared';
import { aliasKey, aliasesDeProveedorUnido, ingredientsWithAlias, reglasDeProveedorUnido, withAlias, withoutAlias, type NoIngredientRule } from '@alexiarest/shared';
import { DEFAULT_SALES_TEAM, type SalesAgentState, type SalesDecision } from '@alexiarest/shared';

const demoSalesStates = new Map<string, SalesAgentState>();
const demoSalesState = (tenantId: string): SalesAgentState => demoSalesStates.get(tenantId) ?? { current: null, history: [], control: { paused: false, note: '' } };
import { ingredientCostShares } from '@alexiarest/shared';
import type { InboxEntry } from '@alexiarest/shared';
import { buildKitchenShareView, KITCHEN_TOKEN_RE, type KitchenLink, type KitchenShareView } from '@alexiarest/shared';
import { corregirIvaDia, estadoIvaAntes, ivaParaCorregir, ventasPorCorregirIva, type EstadoIvaAntes, type RespuestaIvaAntes, type VentasIvaAntes } from '@alexiarest/shared';
import { CUADRE_TODOS, rememberMapping, type CuadreFuente, type RevenueFill, type SavedImportMapping } from '@alexiarest/shared';
import { normalizeIngredientName, type RecipeProposal, type Unit, type PriceEstimate } from '@alexiarest/shared';
import { esFotoGuardable, colchonDeCuenta, sigueColchonDeCuenta, purchaseUnitSchema, catalogCompleteness, nextQuestions, resolvePriceAnswer, skipQuestion, puedeEscanear, inboundEmailSinEscanerMessage, type QuestionHistory } from '@alexiarest/shared';
import { DRAFT_TTL_SECONDS, draftIsExpired, type Draft } from '@alexiarest/shared';
// Bloque I (Finanzas): préstamos, inversiones y objetivos para siempre, igual que la API.
import {
  addMonths as sumarMeses,
  contextoObjetivos,
  gastosQueParecenInversiones,
  interesesAMano,
  inversionDesdeGasto,
  investmentInputSchema as investmentSchemaDemo,
  isStandingTarget,
  loanInputSchema,
  mismosParaTodos,
  objetivoDeLaVista,
  resolverObjetivo,
  STANDING_TARGET_MONTH,
  standingTargetInputSchema,
  type Loan,
} from '@alexiarest/shared';
import {
  allocateTaxPayment,
  camposDeReparto,
  prorratearGastos,
  amortizationSchedule,
  analyzePricing,
  estimatePrice,
  netPriceOf,
  benchmarkKpis,
  businessOverview,
  buildContext,
  buildExpenseDraft,
  categoriasPorProveedor,
  conPreciosDeCatalogo,
  fusionarPaginas,
  ivaEnFrase,
  type ScannedDocument,
  buscarDuplicado,
  invoiceLinesToCatalogProposal,
  catalogPriceInput,
  buildInventoryDraft,
  cashAlerts,
  comparePlatforms,
  compareTargets,
  computeCashFlow,
  computeKpis,
  computeProfitAndLoss,
  computeRecipeCost,
  computeRecipeCostPartial,
  CostingError,
  UnitError,
  currentMonth,
  demoDatasetMx as demoDataset,
  demoMxSuppliers,
  demoMxTenantName,
  DEMO_MX_RECIPE_PROPOSAL,
  findCostDeviations,
  ingredientDisplayName,
  inPeriod,
  menuEngineering,
  unitsSoldFor,
  withUnitsForLocation,
  monthlyProfitAndLoss,
  payables,
  PREDEFINED_ROLES,
  PLANS,
  billingCurrency,
  puedeComprarEscaneos,
  scanQuota,
  scanQuotaMessage,
  separarRepetidos,
  conNaturalezaDeCategoria,
  consolidateTargets,
  parteDelLocalPorMes,
  conImporteDelLocal,
  allocateSharedInvestments,
  allocateSharedLoans,
  cuadreAlJuntar,
  gastosQueCuentan,
  repartoAlJuntar,
  totalDeGasto,
  ultimaFechaDePago,
  projectCashFlow,
  purchaseFormatLabel,
  planRecipeProposal,
  RECIPE_FIXTURES,
  CROQUETAS_FIXTURE,
  ordenarPropuestas,
  type ContextoAlta,
  proposalToImportRows,
  totalDue,
  valueInventoryLines,
  weekdayPerformance,
} from '@alexiarest/shared';
import type {
  PurchaseDocumentType,
  AdminOverview,
  CashMovement,
  CashMovementInput,
  CustomRole,
  CustomRoleInput,
  DailyRevenue,
  DailyRevenueInput,
  ExpenseEntry,
  ExpenseInput,
  FinanceInput,
  Ingredient,
  IngredientInput,
  Investment,
  InvestmentInput,
  InventoryCount,
  InventoryCountInput,
  Membership,
  MenuItem,
  MenuItemInput,
  Period,
  PricingAnalysis,
  Recipe,
  CostingCulprit,
  RecipeCost,
  RecipeInput,
  Supplier,
  Target,
  TargetInput,
  Tenant,
  TenantSettings,
} from '@alexiarest/shared';
/* Fase 7: ventas por plato con fechas y recuento con fecha/tipo/local. */
import {
  addMonths as addMonthsF7,
  buildDishSalesPeriod,
  checkCountDate,
  comprasDeMateriaPrima,
  estimarCierreAtrasado,
  periodoCierreAtrasado,
  COUNTRY_TIMEZONE,
  zonaDelNavegadorAprovechable,
  dishSalesInputSchema,
  salesRangeOf,
  effectiveLocationId,
  SHARED_LOCATION_ID,
  withUnitsFromDishSales,
  countKind,
  inventoryResult,
  isLatestDishSales,
  lastDayOfMonth,
  mergeInventoryCount,
  revenueOf as revenueOfF7,
  sameInventoryCount,
  unitsInRange,
  type DishSalesInput,
  type DishSalesPeriod,
  type InventoryCountKind,
  type InventoryResult,
} from '@alexiarest/shared';
// Bloque S · escáner único.
import {
  ESTADISTICAS_VACIAS,
  filasPorRevisar,
  gastoDesdeEscaneo,
  guardarLasNDisponible,
  motivosParaRevisar,
  notasSinFacturaDe,
  precioDePresentacion,
  REGLAS_ESCANER,
  vencimientoDe,
  type ContextoEscaner,
  type EstadisticasEscaner,
  type PurchaseUnit as UnidadDeCompra,
} from '@alexiarest/shared';
import type {
  AlexiaRestApi,
  BatchResult,
  ConfirmRecipeProposalInput,
  ConfirmRecipeProposalResponse,
  IngredientBatch,
  InventoryScanResult,
  RecipeBatch,
  RecipeImportInput,
  RecipeProposalResponse,
  SupplierInput,
} from './contract';
import {
  guessRevenueColumns,
  guessUnitsColumns,
  helpScreenById,
  normalizeText,
  ingredientUsage,
  ingredientUsageMessage,
  recipeUsage,
  recipeUsageMessage,
  targetKey,
  type PosIntegrationsResponse,
  type BillingInterval,
} from '@alexiarest/shared';
import { demoChat, demoSuggestions, type DemoAssistantData } from './demoAssistant';
import { crearSubirTodoDemo } from './demoSubirTodo';
import { ApiError } from './error';
import type {
  AmortizationRow,
  AssistantChatRequest,
  AssistantChatResponse,
  AssistantSuggestion,
  CashFlowResponse,
  CostDeviation,
  DashboardResponse,
  KpisResponse,
  MeResponse,
  TeamResponse,
  PayablesResponse,
  MapeoVentasPropuesta,
  PricingResponse,
  RecipeCostsResponse,
  ReconciliationResult,
  TaxAllocationRequest,
  TenantUpdate,
} from './types';

/* ------------------------------------------------------------------ */
/* Estado en memoria                                                   */
/* ------------------------------------------------------------------ */

const TENANT_ID = 'demo';

interface DemoState {
  tenant: Tenant;
  user: Membership;
  settings: TenantSettings;
  suppliers: Supplier[];
  ingredients: Ingredient[];
  recipes: Recipe[];
  menuItems: MenuItem[];
  revenues: DailyRevenue[];
  expenses: ExpenseEntry[];
  investments: Investment[];
  cashMovements: CashMovement[];
  targets: Target[];
  inventoryCounts: InventoryCount[];
  /** Bloque I: préstamos (el del horno, para enseñar la sección). */
  loans: Loan[];
  /** Roles personalizados (mejora 70): en la demo se pueden montar y probar. */
  customRoles: CustomRole[];
  /** Fase 7: cargas de ventas por plato con fechas. */
  dishSales: DishSalesPeriod[];
  /** Fase 7: «No se usa aquí» del recuento, por local. */
  inventoryNotUsed: Record<string, string[]>;
}

const clone = <T,>(value: T): T => JSON.parse(JSON.stringify(value)) as T;

/** Fecha de dentro de N dias, en YYYY-MM-DD. */
/** Ofertas de retención enseñadas en la demo (en la API, `RETENCIONOFERTA#<ISO>`). */
const demoOfertasDeRetencion: Array<{ flujoId: string; fecha: string; oferta: OfertaRetencion; aceptada: boolean }> = [];

/** Fin del periodo pagado en la demo: dentro de 29 días, a medianoche UTC. */
function finDePeriodoDemo(): string {
  const d = new Date();
  d.setUTCHours(0, 0, 0, 0);
  d.setUTCDate(d.getUTCDate() + 29);
  return d.toISOString();
}

function enDias(dias: number): string {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() + dias);
  return d.toISOString().slice(0, 10);
}

function initialState(): DemoState {
  const settings = clone(demoDataset.settings);
  return {
    tenant: {
      tenantId: TENANT_ID,
      name: demoMxTenantName,
      /*
       * Mexico y pesos, no España y euros: la demo enseña la cuenta de Alex y
       * el resto de la ficha (RFC, direccion de CDMX) ya es mexicana. Ver un
       * negocio mexicano facturando en euros parece que la moneda no funciona
       * (Alex, 2 sep 2026).
       */
      country: 'MX',
      currency: 'MXN',
      plan: 'trial',
      subscriptionStatus: 'trialing',
      /*
       * La prueba se mueve con la demo, no se queda clavada a una fecha: el
       * 15 de agosto de 2026 ya habia pasado y la demo se ensenyaba con la
       * prueba caducada. Dos semanas por delante, siempre.
       */
      trialEndsAt: enDias(14),
      /*
       * Datos de factura de ejemplo: en la demo se enseña la pantalla llena,
       * que es la unica forma de que se entienda para que sirve.
       *
       * Son los de Alex a peticion suya (1 sep 2026): graba los tutoriales con
       * esta demo y quiere que la cuenta que sale sea la suya. El pais fiscal
       * es Mexico porque ABCA090909D45 tiene forma de RFC: con España, la
       * pantalla marcaria el identificador como invalido y saldria un error
       * rojo en mitad del video.
       */
      tax: {
        legalName: 'ALEJANDRO CORTIJO ROMEU',
        taxId: 'ABCA090909D45',
        taxCountry: 'MX',
        addressLine: 'Av. Insurgentes Sur 1234, piso 2',
        postalCode: '03100',
        city: 'Ciudad de México',
        province: 'CDMX',
      },
      settings,
      createdAt: demoDataset.period.start + 'T00:00:00.000Z',
    },
    user: {
      tenantId: TENANT_ID,
      userId: 'demo-user',
      email: 'demo@alexiarest.app',
      name: 'Cuenta de demostración',
      role: 'owner',
      createdAt: '2026-02-01T00:00:00.000Z',
    },
    settings,
    suppliers: clone(demoMxSuppliers).map((s) => ({ ...s, tenantId: TENANT_ID })),
    ingredients: clone(demoDataset.ingredients),
    recipes: clone(demoDataset.recipes),
    menuItems: clone(demoDataset.menuItems),
    // Datos de ejemplo, no tecleados: no entran en «¿las anotabas con o sin IVA?».
    revenues: clone(demoDataset.revenues).map((r) => ({ ...r, source: 'demo' })),
    expenses: [...clone(demoDataset.expenses), ...notasDeDemo()],
    investments: clone(demoDataset.investments),
    cashMovements: clone(demoDataset.cashMovements) as CashMovement[],
    targets: clone(demoDataset.targets),
    inventoryCounts: clone(demoDataset.inventoryCounts),
    loans: demoLoans(),
    customRoles: [],
    dishSales: demoDishSales(),
    inventoryNotUsed: {},
  };
}

/**
 * Bloque G (14 oct 2026): cuatro notas de Lácteos del Valle sin factura y la
 * factura del mes que las junta, sin juntar todavía. Así la demo enseña
 * «Tienes 4 notas de Lácteos del Valle sin factura. ¿Esta factura las junta?»
 * y el atajo «suman justo». Mientras no se juntan, las dos cuentan (como en
 * la vida real hasta que se juntan).
 */
function notasDeDemo(): ExpenseEntry[] {
  // El último mes cerrado: las cuatro notas y la factura del mes ya pasaron (nada con fecha futura).
  const mes = addMonthsF7(demoDataset.period.end.slice(0, 7), -1);
  const base = {
    tenantId: TENANT_ID,
    supplierId: 'sup-lacteos',
    category: 'compras_materia_prima' as const,
    nature: 'variable' as const,
    vatPct: 0,
    paymentType: 'contado' as const,
  };
  const nota = (dia: string, total: number, numero: string): ExpenseEntry => ({
    ...base,
    entryId: `exp-nota-lacteos-${numero}`,
    date: `${mes}-${dia}`,
    concept: 'Leche y quesos',
    invoiceNumber: numero,
    netAmount: total,
    invoiceTotal: total,
    paid: true,
    paymentDate: `${mes}-${dia}`,
    documentType: 'albaran',
    invoiceStatus: 'pendiente',
  });
  return [
    nota('03', 512.3, 'R-118'),
    nota('10', 498.1, 'R-124'),
    nota('17', 530.4, 'R-131'),
    nota('24', 505.7, 'R-137'),
    {
      ...base,
      entryId: 'exp-factura-lacteos-mes',
      date: `${mes}-28`,
      concept: 'Leche y quesos del mes',
      invoiceNumber: 'F-8812',
      netAmount: 2046.5,
      invoiceTotal: 2046.5,
      paid: true,
      paymentDate: `${mes}-28`,
      documentType: 'factura',
      invoiceStatus: 'facturado',
    },
  ];
}

/**
 * Fase 7: la demo enseña «Con tus ventas del 1 al 30 de septiembre». Las
 * unidades de la carta de ejemplo se dan como cargadas del mes anterior al
 * último de la demo (que ya terminó).
 */
function demoDishSales(): DishSalesPeriod[] {
  const month = addMonthsF7(demoDataset.period.end.slice(0, 7), -1);
  /*
   * Las unidades de la carta de ejemplo no llegan al 80 % de lo que vende la
   * demo en un mes, y sin eso el recuento no compara con las recetas. Se
   * escalan para cubrir ~90 %: la demo enseña la tarjeta completa.
   */
  const ventas = demoDataset.revenues
    .filter((d) => d.date.startsWith(month))
    .reduce((a, d) => a + revenueOfF7(d), 0);
  const cubiertas = demoDataset.menuItems.reduce(
    (a, m) => a + (m.unitsSold ?? 0) * (m.sellingPriceGross / (1 + (m.vatPct ?? 0) / 100)),
    0,
  );
  const factor = cubiertas > 0 && ventas > 0 ? (0.9 * ventas) / cubiertas : 1;
  return [
    buildDishSalesPeriod(
      TENANT_ID,
      {
        start: `${month}-01`,
        end: lastDayOfMonth(month),
        source: 'excel',
        lines: demoDataset.menuItems.map((m) => ({ menuItemId: m.menuItemId, units: Math.round((m.unitsSold ?? 0) * factor) })),
      },
      `${lastDayOfMonth(month)}T23:00:00.000Z`,
    ),
  ];
}

let state: DemoState = initialState();
let purchasePresentations: string[] = [];
/** Fase 7: «No es un ingrediente» recordado, como NOING# en la API. */
let noIngredientRules: NoIngredientRule[] = [];
let drafts: Draft[] = [];
let inbox: InboxEntry[] = [];
let questionHistory: Record<string, QuestionHistory> = {};
let answeredDemoQuestions = new Set<string>();
const draftLinks = new Map<string, { id: string; expiresAt: number }>();
/** Fase 7: enlaces públicos de cocina por receta (KLINK# en la API). */
const demoKitchenLinks = new Map<string, KitchenLink>();
/** 144 bits de azar en base64url, como randomBytes(18) en la API. */
function demoKitchenToken(): string {
  const bytes = new Uint8Array(18);
  crypto.getRandomValues(bytes);
  return btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
const confirmingDrafts = new Map<string, Promise<Draft>>();

/*
 * `?primer-dia=plato|factura|ventas` (alta del 15 oct 2026): la demo como una
 * cuenta recién creada desde el chat (Panel del primer día con «Para
 * empezar» y el lateral de lo elegido abierto). `&hechas=plato,factura`
 * conserva esa parte de los datos de ejemplo, para ver «N de 3».
 * `?configurar` y `?configuracion-inicial` (el cuestionario de antes,
 * retirado) entran igual.
 */
if (typeof window !== 'undefined') {
  const params = new URLSearchParams(window.location.search);
  const elegido = params.get('primer-dia') ?? (params.has('configurar') || params.has('configuracion-inicial') ? 'plato' : null);
  if (elegido) {
    const empiezaPor: EmpiezaPor = elegido === 'factura' || elegido === 'ventas' ? elegido : 'plato';
    const hechas = new Set((params.get('hechas') ?? '').split(',').map((h) => h.trim()));
    state.tenant.setup = { step: SETUP_LAST_STEP, recipeFirstPending: false, completedAt: new Date().toISOString() };
    state.tenant.primerosPasos = { empiezaPor, hechos: [] };
    state.tenant.trialEndsAt = enDias(14);
    state.settings.platforms = state.settings.platforms.map((p) => ({ ...p, commissionPending: true }));
    state.tenant.settings = state.settings;
    if (!hechas.has('plato')) { state.ingredients = []; state.recipes = []; state.menuItems = []; }
    if (!hechas.has('factura')) state.expenses = [];
    if (!hechas.has('ventas')) state.revenues = [];
    // Los avisos de la primera vez solo salen en la demo así (AvisoPrimeraVez).
    try { sessionStorage.setItem('alexia:demo-primer-dia', '1'); } catch { /* sin avisos */ }
  }
}

/*
 * `?ventas-con-iva-antes=1` (19 oct 2026): las ventas de ejemplo como si se
 * hubieran anotado a mano antes del corte de IVA, para ver la pregunta «Tus
 * ventas de antes, ¿las anotabas con o sin IVA?» al abrir «Anotar el día».
 */
if (typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('ventas-con-iva-antes') === '1') {
  state.revenues = state.revenues.map((r) => ({ ...r, source: 'manual', updatedAt: '2026-10-15T12:00:00.000Z' }));
}

/*
 * `?novedades=1` (lanzamiento, 18 oct 2026): la demo enseña el pop-up «Alexia
 * tiene nueva cara», como a una cuenta anterior al corte. Sin el parámetro no
 * sale (los smokes de siempre no lo ven). «Entendido» se recuerda en la
 * pestaña, como la API lo recuerda en la membresía.
 */
const CLAVE_DEMO_NOVEDADES = 'alexia:demo-novedades';
const CLAVE_DEMO_NOVEDADES_VISTO = 'alexia:demo-novedades-visto';
function demoConNovedades(): boolean {
  try { return sessionStorage.getItem(CLAVE_DEMO_NOVEDADES) === '1'; } catch { return false; }
}
if (typeof window !== 'undefined') {
  if (new URLSearchParams(window.location.search).get('novedades') === '1') {
    try { sessionStorage.setItem(CLAVE_DEMO_NOVEDADES, '1'); } catch { /* sin pop-up */ }
  }
  try {
    if (sessionStorage.getItem(CLAVE_DEMO_NOVEDADES_VISTO) === '1') state.user = { ...state.user, avisosVistos: conAvisoVisto(state.user.avisosVistos, NOVEDADES_ID) };
  } catch { /* sin almacenamiento */ }
}

/**
 * `?locales=3` (bloque C, 14 oct 2026): la demo con varios locales, para
 * enseñar y revisar el selector «Todos los locales (3)», la sección «Cada
 * local» y el «Falta Centro» / «Norte cerró» del día a día. Sin el parámetro,
 * la demo sigue con un solo local (los smokes cuentan con eso).
 */
export function sembrarLocalesDemo(cuantos: number): void {
  const extra = [
    { locationId: 'norte', name: 'Norte', factor: 0.78, closedWeekdays: [2] },
    { locationId: 'playa', name: 'Playa', factor: 0.6, closedWeekdays: [] as number[] },
    { locationId: 'puerto', name: 'Puerto', factor: 0.5, closedWeekdays: [1] },
  ].slice(0, Math.max(1, Math.min(cuantos, 4)) - 1);
  demoLocation = { ...demoLocation, name: 'Centro' };
  demoOtrosLocales = extra.map((l) => ({ tenantId: TENANT_ID, locationId: l.locationId, name: l.name, active: true, closedWeekdays: l.closedWeekdays }));
  state.tenant = { ...state.tenant, bonusLocations: extra.length };
  demoPos = [
    conexionDemo('revo', 'demo-revo', 'Taquería Centro', 'principal', 1),
    ...(extra.some((l) => l.locationId === 'norte') ? [conexionDemo('loyverse', 'demo-loyverse', 'Taquería Norte', 'norte', 2)] : []),
  ];
  const ayer = enDias(-1);
  const antier = enDias(-2);
  const escala = (r: DailyRevenue, f: number, locationId: string): DailyRevenue => ({
    ...r,
    locationId,
    inHouse: { efectivo: Math.round((r.inHouse?.efectivo ?? 0) * f * 100) / 100, tarjeta: Math.round((r.inHouse?.tarjeta ?? 0) * f * 100) / 100, otros: Math.round((r.inHouse?.otros ?? 0) * f * 100) / 100 },
    delivery: Object.fromEntries(Object.entries(r.delivery ?? {}).map(([k, v]) => [k, Math.round((v ?? 0) * f * 100) / 100])),
    customers: r.customers ? Math.round(r.customers * f) : r.customers,
  });
  const principales = state.revenues.filter((r) => !r.locationId || r.locationId === 'principal');
  const diaSemana = (fecha: string) => new Date(`${fecha}T00:00:00Z`).getUTCDay();
  // A Norte le falta el último día que abre (ayer, salvo que ayer cerrara: si
  // no, un miércoles el aviso no diría nada de Norte).
  let faltaNorte = ayer;
  for (let d = -1; d >= -7; d--) {
    const fecha = enDias(d);
    if (fecha !== antier && !extra.find((l) => l.locationId === 'norte')?.closedWeekdays.includes(diaSemana(fecha))) { faltaNorte = fecha; break; }
  }
  const nuevas: DailyRevenue[] = [];
  for (const l of extra) {
    for (const r of principales) {
      if (l.closedWeekdays.includes(diaSemana(r.date))) continue;
      if (l.locationId === 'norte' && r.date === faltaNorte) continue;
      nuevas.push(escala(r, l.factor, l.locationId));
    }
  }
  // «Falta Centro» antier.
  state.revenues = [...state.revenues.filter((r) => r.date !== antier), ...nuevas];
}

/** Devuelve el estado a los datos de fábrica (usado desde Ajustes). */
export function resetDemoState(): void {
  purchasePresentations = [];
  state = initialState();
  demoLocation = { tenantId: TENANT_ID, locationId: 'principal', name: 'Principal', active: true };
  demoOtrosLocales = [];
  demoPos = [];
  drafts = []; inbox = [];
  demoScanStats = { ...ESTADISTICAS_VACIAS };
  demoKitchenLinks.clear();
  questionHistory = {}; answeredDemoQuestions = new Set();
  demoImportMappings = {}; demoCuadre = [];
}

/** Periodo por defecto que cubre todos los datos de demostración. */
export const demoPeriod: Period = { ...demoDataset.period };

let counter = 0;
function newId(prefix: string): string {
  counter += 1;
  return `${prefix}-${Date.now().toString(36)}-${counter}`;
}

const nowIso = (): string => new Date().toISOString();

/** Un registro sin centro pertenece al principal, como en la API real. */
const sameLocation = (a?: string, b?: string): boolean =>
  (a?.trim() || 'principal') === (b?.trim() || 'principal');

const notFound = (what: string) =>
  new ApiError('NOT_FOUND', `No hemos encontrado ${what}.`, 404);

/** Proveedores unidos (id que desapareció → el que se quedó), como `SUPMERGED#` en la API. */
const proveedoresUnidos = new Map<string, string>();

/** Como `resolveSupplierId` de la API: el que existe, aquel con el que se unió, o ninguno. */
function proveedorVigente(supplierId: string | undefined): string | undefined {
  let id = supplierId;
  for (let salto = 0; id && salto < 5; salto++) {
    if (state.suppliers.some((s) => s.supplierId === id)) return id;
    id = proveedoresUnidos.get(id);
  }
  return undefined;
}

/** Como `requireActiveLocation` de la API. */
function requireDemoActiveLocation(locationId?: string): string {
  const effective = effectiveLocationId(locationId);
  if (effective === SHARED_LOCATION_ID) return effective;
  const local = todosLosLocales().find((l) => l.locationId === effective);
  if (!local) throw new ApiError('VALIDATION_ERROR', 'El centro seleccionado no existe.', 400);
  if (!local.active) throw new ApiError('VALIDATION_ERROR', 'El centro seleccionado está desactivado.', 400);
  return effective;
}

/** Hoy en la zona del restaurante, como `tenantTodayIso` de la API; sin zona, la del navegador. */
function hoyDelNegocio(): string {
  const timeZone = state.tenant.timezone ?? COUNTRY_TIMEZONE[state.tenant.country ?? ''];
  try {
    return new Intl.DateTimeFormat('en-CA', { ...(timeZone ? { timeZone } : {}), year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
  } catch {
    return new Date().toISOString().slice(0, 10);
  }
}

/* ------------------------------------------------------------------ */
/* Calculo                                                             */
/* ------------------------------------------------------------------ */

/**
 * Espejo de `resumenDePrueba` (api/src/finPrueba.ts): lo que consiguió con
 * sus datos en la prueba y el plan que le recomendamos.
 */
function resumenDePruebaDemo(): ResumenPrueba {
  const ahora = Date.now();
  const hoy = todayIso();
  const tenant = state.tenant;
  const ctx = buildContext(state.ingredients.filter((i) => !i.pricePending && !i.priceEstimated), state.recipes);
  const recetas = new Map(state.recipes.map((r) => [r.recipeId, r]));
  let platosCosteados = 0;
  let platoEstrella: ResumenPrueba['platoEstrella'];
  for (const item of state.menuItems) {
    const receta = recetas.get(item.recipeId);
    if (!item.active || !receta?.active || !receta.components.length || item.sellingPriceGross <= 0) continue;
    try {
      const costo = computeRecipeCost(item.recipeId, ctx);
      if (costo.status === 'partial' || costo.costEstimated || costo.baseCost <= 0) continue;
      platosCosteados += 1;
      if (item.platformId) continue;
      const deja = analyzePricing(item, costo, state.settings).grossMargin;
      if (Number.isFinite(deja) && (!platoEstrella || deja > platoEstrella.dejaLocal)) platoEstrella = { nombre: item.name, dejaLocal: Math.round(deja * 100) / 100 };
    } catch {
      /* a medias no cuenta */
    }
  }
  const facturas = state.expenses.filter((e) => (e.documentType ?? 'factura') === 'factura' && e.netAmount > 0 && !e.porConfirmar).length;
  const diasConVentas = new Set(state.revenues.filter((r) => revenueOf(r) > 0).map((r) => r.date)).size;
  let resultado: ResumenPrueba['resultado'];
  const mesActual = hoy.slice(0, 7);
  const [y, m] = mesActual.split('-').map(Number);
  const mesAnterior = m === 1 ? `${y - 1}-12` : `${y}-${String(m - 1).padStart(2, '0')}`;
  for (const mes of [mesActual, mesAnterior]) {
    const dias = state.revenues.filter((r) => r.date.startsWith(mes) && r.date <= hoy && revenueOf(r) > 0).map((r) => r.date).sort();
    if (!dias.length) continue;
    const periodo = { start: `${mes}-01`, end: dias[dias.length - 1] };
    const pnl = computeProfitAndLoss(financeInput(), periodo);
    if (pnl.revenue > 0 && pnl.materialConsumption + pnl.operatingExpenses + pnl.laborCost > 0) resultado = { desde: periodo.start, hasta: periodo.end, ventas: pnl.revenue, teQuedo: pnl.netProfit };
    break;
  }
  const inicio = (tenant.createdAt ?? hoy).slice(0, 10);
  const uso = {
    usuarios: 1,
    locales: Math.max(1, todosLosLocales().filter((l) => l.active).length),
    escaneos: demoScans,
    mensajes: 0,
    diasUsados: Math.max(1, Math.min(TRIAL_DAYS, Math.round((Date.parse(hoy) - Date.parse(inicio)) / 86_400_000) + 1)),
  };
  const nombre = state.user.name?.trim().split(/\s+/)[0];
  return {
    restaurante: tenant.name,
    ...(nombre && !/^cuenta$/i.test(nombre) ? { nombre } : {}),
    ...(tenant.trialEndsAt ? { trialEndsAt: tenant.trialEndsAt } : {}),
    diasQueQuedan: diasQueQuedanDePrueba(tenant.trialEndsAt, ahora, zonaDeLaPrueba(tenant)),
    fase: fasePrueba(tenant, ahora),
    platosCosteados,
    ...(platoEstrella ? { platoEstrella } : {}),
    facturas,
    ...(resultado ? { resultado } : {}),
    diasConVentas,
    uso,
    recomendacion: recomendarPlan(uso),
    moneda: tenant.currency ?? 'EUR',
  };
}

function context() {
  return buildContext(state.ingredients, state.recipes);
}

let demoLocation: import("@alexiarest/shared").Location = { tenantId: TENANT_ID, locationId: "principal", name: "Principal", active: true };
/** Locales además del principal (bloque C). La demo arranca con uno; `?locales=3` siembra tres. */
let demoOtrosLocales: LocalDemo[] = [];

/**
 * Puntos de venta de la demo (15 oct 2026). Con un local, ninguno (los smokes
 * cuentan con eso). Con `?locales=`, cada local el suyo, para enseñar que
 * «Pro con 2 locales» conecta uno por local: Centro con Revo XEF y Norte con
 * Loyverse; Playa y Puerto, sin conectar. Espejo de /v1/integrations/pos.
 */
let demoPos: import('@alexiarest/shared').PosIntegrationView[] = [];
function conexionDemo(provider: import('@alexiarest/shared').PosProvider, connectionId: string, merchantName: string, locationId: string, diasAtras: number): import('@alexiarest/shared').PosIntegrationView {
  const ayer = enDias(-diasAtras);
  return {
    provider, connectionId, status: 'connected', merchantName, merchantCurrency: 'EUR', authType: provider === 'loyverse' ? 'token' : 'oauth',
    connectedAt: `${enDias(-40)}T10:00:00.000Z`, connectedBy: 'demo@alexiarest.com',
    stores: [{ externalId: `${connectionId}-tienda`, externalName: merchantName, locationId }],
    timezone: 'Europe/Madrid', businessDayStartHour: 5, itemMappings: {},
    lastSyncAt: `${enDias(0)}T04:00:00.000Z`, lastSaleDate: ayer, lastSyncRange: { start: enDias(-2), end: enDias(0) },
  };
}
const todosLosLocales = (): LocalDemo[] => [demoLocation, ...demoOtrosLocales];

/**
 * El horno de la demo se pagó con un préstamo: 36 cuotas al 1 % mensual por
 * el 80 % de su precio, desde el mes de compra.
 */
function demoLoans(): Loan[] {
  const horno = demoDataset.investments.find((i) => i.investmentId === 'inv-horno');
  if (!horno) return [];
  const principal = Math.round(horno.unitPrice * (horno.quantity ?? 1) * 0.8);
  const r = 0.01;
  const n = 36;
  const payment = Math.round(((principal * r) / (1 - Math.pow(1 + r, -n))) * 100) / 100;
  return [{ tenantId: TENANT_ID, loanId: 'loan-horno', name: 'Préstamo del banco', principal, payment, installments: n, startDate: horno.date, investmentId: horno.investmentId }];
}

/** Lo que pide la web (`undefined`, «id» o «a,b»), como `ambitoQuery` de la API. */
function ambitoDemo(locationId?: string): string[] | undefined {
  const lista = leerAmbito(locationId);
  if (lista === null) throw new ApiError('VALIDATION_ERROR', 'El centro seleccionado no es válido.', 400);
  return lista;
}

/** Objetivo efectivo de un mes en la demo, como `getTargetForScope` de la API (uno, varios o todos). */
function objetivoDemo(month: string, locationId?: string): Target {
  const lista = ambitoDemo(locationId);
  const activos = todosLosLocales().filter((l) => l.active).map((l) => l.locationId);
  if (!lista || lista.length === 0 || (lista.length > 1 && esTodoElGrupo(lista, activos))) {
    return objetivoDeLaVista(state.targets, { tenantId: TENANT_ID, month, locationIds: activos, revenues: state.revenues });
  }
  // Como la API: con «los mismos para todos», cada local con su parte de las ventas del grupo.
  if (lista.length === 1) return objetivoDeLaVista(state.targets, { tenantId: TENANT_ID, month, locationId: lista[0], locationIds: activos, revenues: state.revenues });
  const porLocal = lista.map((id) => objetivoDeLaVista(state.targets, { tenantId: TENANT_ID, month, locationId: id, locationIds: activos, revenues: state.revenues }));
  return consolidateTargets(porLocal) ?? { tenantId: TENANT_ID, month };
}

/** Como `loadFinance` de la API: todos, un local o varios (con su parte de los comunes). */
function financeInput(locationId?: string): FinanceInput {
  const lista = ambitoDemo(locationId);
  const locales = todosLosLocales();
  const activos = locales.filter((l) => l.active).map((l) => l.locationId);
  // Igual que `analysis.ts`: primero qué cuenta (notas el día de cada nota,
  // juntadas una vez, «Por confirmar» no), luego fijo o variable por
  // categoría, luego los pagos que cubren varios meses, por partes, y al final
  // los locales.
  const accountingExpenses = prorratearGastos(conNaturalezaDeCategoria(gastosQueCuentan(state.expenses), state.settings), state.revenues);
  const base = {
    cashMovements: state.cashMovements.filter((m) => enAmbito(m.locationId, lista)),
    inventoryCounts: state.inventoryCounts.filter((c) => enAmbito(c.locationId, lista)),
  };
  if (!lista || (lista.length > 1 && esTodoElGrupo(lista, activos))) {
    return { locations: locales, revenues: state.revenues, expenses: accountingExpenses, investments: state.investments, loans: state.loans, ...base };
  }
  const allocation = state.settings.sharedCostAllocation;
  // Como la API: lo «de todos» se reparte mes a mes con las ventas de cada mes.
  const parteDe = (id: string) => parteDelLocalPorMes({ locationId: id, activeLocationIds: activos, allocation, revenues: state.revenues });
  return {
    locations: locales.filter((l) => lista.includes(l.locationId)),
    revenues: state.revenues.filter((r) => enAmbito(r.locationId, lista)),
    expenses: gastosDeLocales({ expenses: accountingExpenses, revenues: state.revenues, locationIds: lista, activeLocationIds: activos, allocation }),
    investments: lista.flatMap((id) => allocateSharedInvestments(state.investments, id, parteDe(id))),
    loans: lista.flatMap((id) => allocateSharedLoans(state.loans ?? [], id, parteDe(id))),
    ...base,
  };
}

function costOf(recipeId: string): RecipeCost {
  try {
    return computeRecipeCost(recipeId, context());
  } catch (error) {
    const message =
      error instanceof Error
        ? error.message
        : 'No hemos podido calcular el costo de la receta.';
    throw new ApiError('VALIDATION_ERROR', message, 400);
  }
}

/** Analisis de precios de toda la carta, saltando platos que no cuadran. */
interface PlatoSinCostear {
  menuItemId: string;
  name: string;
  reason: string;
  culprit?: CostingCulprit;
}

/**
 * Platos costeados y platos que no han podido costearse, CON su motivo.
 *
 * El motivo y el culpable se guardan al vuelo: la demo los tiraba y luego
 * reconstruia la lista por diferencia, asi que todos los platos salian con un
 * "No se ha podido calcular el coste" generico y sin manera de saber que
 * subreceta lo provocaba. La API si los tenia; aqui no.
 */
function pricingItems(): {
  rows: Array<{ item: MenuItem; analysis: PricingAnalysis; cost: RecipeCost }>;
  skipped: PlatoSinCostear[];
} {
  const rows: Array<{ item: MenuItem; analysis: PricingAnalysis; cost: RecipeCost }> = [];
  const skipped: PlatoSinCostear[] = [];
  const ctx = context();
  // Igual que la API real: los inactivos tambien se costean (el filtro de
  // estado de la pantalla decide que se ve). Saltarselos aqui escondia en la
  // demo lo que en produccion si aparecia (mejora 60 de Alex, 6 sep 2026).
  for (const item of state.menuItems) {
    try {
      const cost = computeRecipeCostPartial(item.recipeId, ctx);
      rows.push({ item, analysis: analyzePricing(item, cost, state.settings), cost });
    } catch (err) {
      // Un plato mal configurado no puede tumbar toda la pantalla de precios.
      skipped.push({
        menuItemId: item.menuItemId,
        name: item.name,
        reason:
          err instanceof Error ? err.message : 'No se pudo calcular el costo de la receta.',
        culprit:
          err instanceof CostingError || err instanceof UnitError ? err.culprit : undefined,
      });
    }
  }
  return { rows, skipped };
}

function payablesResponse(today: string, locationId?: string): PayablesResponse {
  const lista = ambitoDemo(locationId);
  // Igual que la API: una nota juntada ya no se debe (la lleva la factura).
  const expenses = state.expenses.filter((e) => !e.reconciledInvoiceId && (enAmbito(e.locationId, lista) || e.locationId === SHARED_LOCATION_ID));
  return { items: payables(expenses, today), totalDue: totalDue(expenses, today) };
}

/** Fecha de hoy en formato YYYY-MM-DD, sin depender del huso. */
/* --- Escaner de facturas (demo) --- */

/** Contador de escaneos de la sesion de demo. Se reinicia con el estado. */
let demoScans = 0;
/** Escaneos comprados este mes con el paquete de 150 (en la demo, nunca: no hay pagos). */
const demoExtraScans = 0;

/** Como `cuotaDe` de la API: plan + locales extra × 150 + paquetes del mes. */
function cuotaDemo() {
  return scanQuota(state.tenant, demoScans, currentMonthDemo(), demoExtraScans);
}

/** Como la API: por qué no puede escanear, con el paquete de 150 si ya paga. */
function mensajeSinEscaneos(): string {
  return scanQuotaMessage(cuotaDemo(), PLANS[state.tenant.plan]?.name ?? state.tenant.plan, {
    puedeComprar: puedeComprarEscaneos(state.tenant),
    moneda: billingCurrency(state.tenant.country),
  });
}

/** Como la API: agotada la cuota, no se lee nada más. */
function exigirEscaneos(): void {
  const q = cuotaDemo();
  if (q.sinModulo || q.exhausted) throw new ApiError('FORBIDDEN', mensajeSinEscaneos(), 403);
}

/* --- Bloque S · escáner único (demo) --- */
/** Métrica de «Guardar las N» de la sesión de demo (la API la guarda por cuenta). */
let demoScanStats: EstadisticasEscaner = { ...ESTADISTICAS_VACIAS };
/** Como la API: una factura escaneada espera 60 días en «Por revisar». */
const DEMO_SCAN_TTL_SECONDS = 60 * 24 * 60 * 60;
function contextoEscanerDemo(): ContextoEscaner {
  return { hoy: todayIso(), suppliers: state.suppliers, expenses: state.expenses, ingredients: state.ingredients };
}

const currentMonthDemo = () => todayIso().slice(0, 7);

/**
 * Factura de ejemplo del escaner. Son los campos tal y como los devolveria
 * Textract, para que la demo recorra EXACTAMENTE el mismo motor de reglas que
 * la app real: si el desglose de base e IVA se rompiera, se romperia aqui.
 *
 * El IVA es del 16 % porque la demo es mexicana: desde que el motor distingue
 * un solo tipo de varios (28 sep 2026), un 10 % espanol en Mexico no es un
 * tipo real y el cajon lo ensenaria como «Varios».
 */
const FACTURA_DEMO = {
  vendorName: { value: 'DISTRIBUCIONES DEL NORTE, S.A. DE C.V.', confidence: 98 },
  /*
   * Fecha y numero de HOY, no clavados.
   *
   * Estaban fijos en agosto de 2026 y envejecieron: en cuanto paso el mes, la
   * factura de ejemplo caia en un mes sin datos y el gasto que creaba no se
   * veia por ningun lado, ni en el periodo de la demo ni en el mes en curso.
   * La demo entera se mueve en el tiempo; esto tambien.
   */
  invoiceNumber: { value: `F-${todayIso().slice(0, 4)}/${todayIso().slice(5).replace('-', '')}`, confidence: 94 },
  invoiceDate: { value: todayIso().split('-').reverse().join('/'), confidence: 96 },
  subtotal: { value: '2612,00', confidence: 95 },
  tax: { value: '417,92', confidence: 95 },
  total: { value: '3029,92', confidence: 99 },
  rawText: 'DISTRIBUCIONES DEL NORTE SA DE CV Alimentos Cerdo Camarón Verduras',
  lines: [
    { description: 'Pierna de cerdo para pastor', quantity: '10 kg', unitPrice: '118,00', total: '1180,00' },
    { description: 'Camarón mediano limpio', quantity: '4 kg', unitPrice: '298,00', total: '1192,00' },
    { description: 'Verduras variadas', quantity: '10 kg', unitPrice: '24,00', total: '240,00' },
  ],
};

/**
 * Factura de ejemplo de DOS paginas y tres tipos de IVA, calcada (con otro
 * nombre) de la que destapo el fallo de los PDF largos en soporte el 21 sep
 * 2026. Son las dos lecturas por pagina, como las deja la API tras partir el
 * PDF, y pasan por `fusionarPaginas` y el mismo motor: el pie con el total
 * repetido en las dos hojas, el subtotal acumulado de la primera (122,35), el
 * «Descuento 8,78» que no es un porcentaje y el abono de envase en negativo.
 */
const facturaDemoDosPaginas = (): ScannedDocument[] => {
  const fecha = todayIso().split('-').reverse().join('/');
  const pie = ['Descuento', '21,00%', '4,03', '0,85', '8,78', '%', '%', '10,00%', '75,92', '7,59', '4,00%', '39,69', '1,59', 'Total Factura', '129,67 €'];
  const cabecera = {
    vendorName: { value: 'Bodegas del Levante', confidence: 96 },
    invoiceNumber: { value: `A/${todayIso().slice(2, 4)}${todayIso().slice(5).replace('-', '')}`, confidence: 99 },
    invoiceDate: { value: fecha, confidence: 99 },
    dueDate: { value: `${fecha} 129,67`, confidence: 97 },
    paymentMethod: { value: 'DOMICILIACION', confidence: 95 },
    total: { value: '129,67 €', confidence: 90 },
  };
  return [
    {
      ...cabecera,
      subtotal: { value: '122,35', confidence: 97 },
      lines: [
        { description: 'LAVAVAJILLAS MANUAL 5L', quantity: '1,000', unitPrice: '7,8500', total: '7,54' },
        { description: 'PALETA YORK LONCHAS 500 GR', quantity: '4,000', unitPrice: '4,2500', total: '16,15' },
        { description: 'PAN BARRITA DE AGUA 140G C/46U', quantity: '1,000', unitPrice: '22,5500', total: '19,84' },
        { description: 'SALMON NORUEGO 500G', quantity: '1,000', unitPrice: '26,9000', total: '25,55' },
        { description: 'TOMATE RALLADO NATURAL 1,1L C/6U', quantity: '2,000', unitPrice: '7,1900', total: '13,52' },
        { description: 'PAN BARRITA DE AGUA 140G C/46U', quantity: '1,000', unitPrice: '22,5500', total: '19,84' },
        { description: 'MERMELADA FRESA PORCIONES', quantity: '1,000', unitPrice: '9,1500', total: '9,15' },
        { description: 'MERMELADA MELOCOTON PORCIONES', quantity: '1,000', unitPrice: '9,1500', total: '9,15' },
      ],
      rawText: 'Bodegas del Levante LAVAVAJILLAS MANUAL 5L PALETA YORK PAN BARRITA SALMON TOMATE MERMELADA',
      fullText: ['Subtotal', '122,35', ...pie].join('\n'),
    },
    {
      ...cabecera,
      subtotal: { value: '119,64', confidence: 98 },
      lines: [{ description: 'ENVASE CERVEZA 24/3', quantity: '-1,000', unitPrice: '3,5100', total: '-3,51' }],
      rawText: 'Bodegas del Levante ENVASE CERVEZA 24/3',
      fullText: ['Subtotal', '119,64', ...pie].join('\n'),
    },
  ];
};

function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}

/** Suma dias a una fecha YYYY-MM-DD. */
function addDaysIso(date: string, days: number): string {
  return new Date(Date.parse(`${date}T00:00:00Z`) + days * 86_400_000).toISOString().slice(0, 10);
}

/** Lo que necesita Alexia para responder: los mismos datos, en crudo. */
function assistantData(): DemoAssistantData {
  return {
    settings: state.settings,
    ingredients: state.ingredients,
    recipes: state.recipes,
    menuItems: state.menuItems,
    revenues: state.revenues,
    expenses: state.expenses,
    investments: state.investments,
    cashMovements: state.cashMovements,
    targets: state.targets,
  };
}

/** Pausa corta para que la pantalla enseñe su estado de "pensando". */
const pause = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

/**
 * Respuesta del manual para preguntas de USO («como hago», «que es»,
 * «donde»). Las de datos («cuanto vendi», «que dia vendo mas») siguen al
 * asistente de datos aunque compartan palabras con el manual. Se elige la
 * FAQ o el parrafo con mas palabras en comun; con menos de dos, nada.
 */
const INTENCION_USO = /^[¿\s]*(c[oó]mo|d[oó]nde|puedo|qu[eé] es|qu[eé] significa|para qu[eé]|por qu[eé])\b/i;
function faqParecida(screenId: string, pregunta: string): string | null {
  if (!INTENCION_USO.test(pregunta.trim())) return null;
  const screen = helpScreenById(screenId);
  if (!screen) return null;
  const VACIAS = new Set(['como', 'que', 'para', 'con', 'los', 'las', 'una', 'del', 'por', 'sin', 'mis', 'tengo', 'puedo', 'hago', 'donde', 'significa']);
  const palabras = (texto: string) =>
    new Set(normalizeText(texto).split(' ').filter((w) => w.length > 2 && !VACIAS.has(w)));
  const mias = palabras(pregunta);
  const candidatos = [
    ...screen.faqs.map((faq) => ({ clave: faq.q, respuesta: faq.a })),
    ...screen.howItWorks.map((p) => ({ clave: p, respuesta: p })),
  ];
  let mejor: { puntos: number; respuesta: string } | null = null;
  for (const c of candidatos) {
    const suyas = palabras(c.clave);
    let puntos = 0;
    for (const w of mias) if (suyas.has(w)) puntos += 1;
    if (puntos >= 2 && (!mejor || puntos > mejor.puntos)) mejor = { puntos, respuesta: c.respuesta };
  }
  return mejor?.respuesta ?? null;
}

/**
 * Doble del estimador del modelo para la demo: en España sale de la tabla
 * local, como en producción; en el resto de países el modelo estima en la
 * moneda del tenant, y aquí lo imitan unas cifras fijas (pesos para México,
 * magnitudes de euro/dólar para cualquier otro). Nunca entran en la base real.
 */
function demoPriceEstimate(name: string, unit: Unit, country: string, currency: string): PriceEstimate | null {
  const local = estimatePrice(name, unit, country, currency);
  if (local) return local;
  const mexico = country === 'MX' && currency === 'MXN';
  const fixtures: Record<string, { unitPrice: number; unit: Unit }> = mexico ? {
    // Los del pozole de la demo («Nuevo plato»): precios de referencia en pesos.
    'maiz pozolero': { unitPrice: 42, unit: 'kg' }, 'maciza cerdo': { unitPrice: 135, unit: 'kg' }, 'rabano': { unitPrice: 30, unit: 'kg' },
    'arroz carnaroli': { unitPrice: 95, unit: 'kg' }, 'caldo verdura': { unitPrice: 45, unit: 'l' },
    'boletus': { unitPrice: 480, unit: 'kg' }, 'harina': { unitPrice: 24, unit: 'kg' },
    'azucar': { unitPrice: 28, unit: 'kg' }, 'mantequilla': { unitPrice: 180, unit: 'kg' },
  } : {
    'maiz pozolero': { unitPrice: 2.1, unit: 'kg' }, 'maciza cerdo': { unitPrice: 6.5, unit: 'kg' }, 'rabano': { unitPrice: 1.5, unit: 'kg' },
    'arroz carnaroli': { unitPrice: 3.4, unit: 'kg' }, 'caldo verdura': { unitPrice: 1.6, unit: 'l' },
    'boletus': { unitPrice: 18, unit: 'kg' }, 'harina': { unitPrice: 0.9, unit: 'kg' },
    'azucar': { unitPrice: 1.1, unit: 'kg' }, 'mantequilla': { unitPrice: 7.5, unit: 'kg' },
  };
  const value = fixtures[normalizeIngredientName(name)];
  return value && value.unit === unit ? { ...value, basis: 'alexia', at: '2026-09-14' } : null;
}

export function previewDemoRecipe(proposal: RecipeProposal) {
  const rows = proposalToImportRows(proposal, state.ingredients, state.recipes);
  if (rows.issues.length) return { issues: rows.issues, newIngredients: rows.ingredientStubs.map((item) => item.name), cost: undefined };
  const virtual = rows.ingredientStubs.map((item, index): Ingredient => ({ ...item, ingredientId: `preview-${index}`, tenantId: TENANT_ID, updatedAt: '', priceEstimated: item.purchaseUnit ? demoPriceEstimate(item.name, item.purchaseUnit, state.tenant.country, state.tenant.currency) ?? undefined : undefined }));
  const row = rows.recipeRows[0];
  const recipe: Recipe = { ...row, tenantId: TENANT_ID, recipeId: 'preview-demo', updatedAt: '', components: row.components.map((line) => ({ ...line, ref: line.ref.kind === 'ingredient_del_fichero' ? { kind: 'ingredient', ingredientId: virtual.find((item) => item.name === (line.ref as { ingredientName: string }).ingredientName)!.ingredientId } : line.ref })) };
  return { issues: rows.issues, newIngredients: virtual.map((item) => item.name), cost: computeRecipeCostPartial(recipe.recipeId, buildContext([...state.ingredients, ...virtual], [...state.recipes, recipe])) };
}

/* ------------------------------------------------------------------ */
/* Adaptador                                                           */
/* ------------------------------------------------------------------ */

// Mapeos de columnas y totales del cuadre: en memoria, como la API del demo.
let demoImportMappings: Record<string, SavedImportMapping[]> = {};
let demoCuadre: CuadreFuente[] = [];
let demoWelcomeEnabled = true;
let demoWeeklyEnabled = true;
// «Súbelo todo» en la demo: el estado vive en el módulo, los datos en `state`.
const subirTodoDemo = crearSubirTodoDemo({
  datos: () => ({
    revenues: state.revenues, expenses: state.expenses, menuItems: state.menuItems, recipes: state.recipes, ingredients: state.ingredients,
    suppliers: state.suppliers.map((s) => ({ supplierId: s.supplierId, name: s.name, taxId: s.taxId })),
    country: state.tenant.country, currency: state.tenant.currency, tpvConectado: false,
  }),
  factura: FACTURA_DEMO,
  hoy: todayIso,
  crearGasto: (input) => demoApiSinCerrojo.createExpense(input),
  crearPlato: async (nombre, precio, seccion) => {
    const { recipe } = await demoApiSinCerrojo.confirmRecipeProposal({ name: nombre, servings: 1, lines: [], ...(seccion ? { group: seccion } : {}) });
    const plato = await demoApiSinCerrojo.createMenuItem({ recipeId: recipe.recipeId, name: nombre, sellingPriceGross: precio, vatPct: state.settings.vatPct ?? 10, targetFoodCostPct: 30, active: true, ...(seccion ? { group: seccion } : {}) });
    return { menuItemId: plato.menuItemId, recipeId: recipe.recipeId };
  },
});

const demoApiSinCerrojo: AlexiaRestApi = {
  ...subirTodoDemo,
  async trialExtension() { return {enabled:false,usage:{dictations:0,scans:0},deliveries:[]}; },
  async acceptTrialExtension() { throw new Error('La demo no activa extensiones.'); },
  async adminTrialExtension() { return {enabled:false,usage:{dictations:0,scans:0},deliveries:[]}; },
  async adminSalesAgent(tenantId) { return demoSalesState(tenantId); },
  async adminSalesTeam() { return structuredClone(DEFAULT_SALES_TEAM); },
  async adminSaveSalesTeam() { throw new Error('La configuración comercial se guarda en Administración.'); },
  async adminCustomerFollowups() { return { items: [] }; },
  async adminCustomerFollowup(tenantId) { return { state: { tenantId, revision: 0, status: 'new', nextContactOn: null, lastContactAt: null, lastNote: '', updatedAt: '' }, notes: [] }; },
  async adminSaveCustomerFollowup() { throw new Error('El seguimiento de clientes solo está disponible en Administración.'); },
  async getSalesWork() { return { team: structuredClone(DEFAULT_SALES_TEAM), tasks: [], manager: false, memberId: null }; },
  async getSalesWorkTask() { throw new Error('No hay tareas reales en la demo.'); },
  async updateSalesWorkTask() { throw new Error('No hay tareas reales en la demo.'); },
  async adminEvaluateSalesAgent(tenantId) {
    const state = demoSalesState(tenantId);
    const current: SalesDecision = { id: crypto.randomUUID(), tenantId, evaluatedAt: new Date().toISOString(),
      stage: state.control.paused ? 'paused' : 'excluded', action: state.control.paused ? 'handoff' : 'wait', priority: 'low',
      title: state.control.paused ? 'Atención humana pendiente' : 'Cuenta de demostración',
      reason: state.control.paused ? state.control.note : 'La demo permite revisar el agente; no prepara contactos reales.',
      evidence: ['Entorno de demostración.'], missingData: [], recipient: null, draft: null, handoffReason: state.control.paused ? state.control.note : null };
    const next = { ...state, current, history: [current, ...state.history].slice(0, 20) };
    demoSalesStates.set(tenantId, next); return next;
  },
  async adminSalesAgentControl(tenantId, control) {
    const next = { ...demoSalesState(tenantId), control: { ...control, updatedAt: new Date().toISOString() } };
    demoSalesStates.set(tenantId, next); return next;
  },
  async adminOfferTrialExtension() { throw new Error('La demo no envía ofertas.'); },
  async adminGrantTrialExtension() { throw new Error('La demo no alarga pruebas.'); },
  async welcomeEmailPreference() { return { enabled: demoWelcomeEnabled, consent: demoWelcomeEnabled }; },
  async setWelcomeEmailPreference(enabled) { demoWelcomeEnabled = enabled; return { enabled, consent: enabled }; },
  async markWelcomeResultViewed() { return { ok: true }; },
  async adminWelcomeHistory() { return { items: [], copyReady: false, sendingEnabled: false }; },
  async weeklyReportPreference() { return { enabled: demoWeeklyEnabled }; },
  async setWeeklyReportPreference(enabled) { demoWeeklyEnabled = enabled; return { enabled }; },
  async getPushSettings() { return { publicKey: null, subscribed: false, preferences: { enabled: true, localHour: 16 } }; },
  async savePushSubscription(_subscription, remove) { return { subscribed: !remove }; },
  async getInboundEmailSettings() {
    // Espejo de routes/inboundEmail.ts: sin escáner no hay dirección.
    if (!puedeEscanear(state.tenant.plan)) return { available: false, configured: false, canChangeSlug: false, allowedSenders: state.tenant.inboundAllowedSenders ?? [], message: inboundEmailSinEscanerMessage(PLANS[state.tenant.plan]?.name ?? state.tenant.plan) };
    return { available: true, configured: false, address: `facturas-${state.tenant.inboundEmailSlug ?? direccionPropuesta(state.tenant.name) ?? 'demo-restaurante'}@facturas.alexiarest.com`, slug: state.tenant.inboundEmailSlug ?? direccionPropuesta(state.tenant.name) ?? 'demo-restaurante', canChangeSlug: false, allowedSenders: state.tenant.inboundAllowedSenders ?? [] };
  },
  async setInboundEmailAddress(slug) {
    if (slug) {
      if (state.tenant.inboundEmailSlugChangedAt) throw new Error('La dirección solo se puede cambiar una vez.');
      if (!/^[a-z0-9][a-z0-9-]{4,30}$/.test(slug)) throw new Error('Usa entre 5 y 31 letras minúsculas, números o guiones.');
      state.tenant.inboundEmailSlug = slug; state.tenant.inboundEmailSlugChangedAt = new Date().toISOString();
    }
    return { address: `facturas-${state.tenant.inboundEmailSlug ?? direccionPropuesta(state.tenant.name) ?? 'demo-restaurante'}@facturas.alexiarest.com`, slug: state.tenant.inboundEmailSlug ?? direccionPropuesta(state.tenant.name) ?? 'demo-restaurante' };
  },
  async setInboundEmailSenders(emails) { state.tenant.inboundAllowedSenders = emails; return { allowedSenders: emails }; },
  async getQuestions() {
    const ingredients = state.ingredients.map((item, index) => index < 3 && !answeredDemoQuestions.has(`price-${item.ingredientId}`) ? { ...item, pricePending: true, priceEstimated: { unitPrice: (item.netPrice ?? item.prices?.[0] ?? 1) / (item.purchaseQty ?? 1), unit: item.purchaseUnit ?? 'kg' as const, basis: 'alexia' as const, at: '2026-09-14' } } : item);
    const completeness = catalogCompleteness(state.recipes, ingredients, state.menuItems);
    return { questions: nextQuestions(state.tenant, { ingredients, recipes: state.recipes, menuItems: state.menuItems, history: questionHistory }, completeness, 1), completeness };
  },
  async skipQuestion(id) { questionHistory[id] = skipQuestion(questionHistory[id]); },
  async answerQuestion(id, answer) {
    const question = (await this.getQuestions()).questions.find((item) => item.id === id);
    if (!question) throw notFound('esa pregunta');
    if (question.kind === 'confirm-price') {
      const ingredient = state.ingredients.find((item) => item.ingredientId === question.ingredientId)!;
      // Mismo calculo que la API: nunca pisa el formato de compra.
      const resolved = resolvePriceAnswer(ingredient, question, answer);
      await this.updateIngredient(ingredient.ingredientId, { ...catalogPriceInput(ingredient, ingredient.name, resolved.price, resolved.qty, resolved.unit), ...(resolved.presentation ? { presentation: resolved.presentation } : {}), priceSource: 'manual' });
      answeredDemoQuestions.add(id);
    }
    return {};
  },
  async getWhatsAppSettings() { return { configured: false }; },
  async requestWhatsAppCode() { throw new Error('La demo no envía mensajes de WhatsApp.'); },
  async verifyWhatsAppCode() { throw new Error('La demo no vincula teléfonos.'); },
  async unlinkWhatsApp() { return { unlinked: true }; },
  async updateWhatsAppPreferences(input) { return input; },
  // En demo no hay onboarding real: el restaurante de ejemplo ya existe.
  async onboard() {
    return { tenant: clone(state.tenant), tokensStale: false };
  },

  // Las fotos en demo viajan como dataURL dentro de la receta (PhotoField
  // no llama a estos metodos en modo demo).
  async createPhotoUploadUrl(): Promise<never> {
    throw new Error('Las fotos en la demo se guardan dentro de la receta.');
  },
  async getPhotoUrl(): Promise<never> {
    throw new Error('Las fotos en la demo se guardan dentro de la receta.');
  },

  async transcribeRecipeAudio(input) {
    const voiceApi = (import.meta.env.VITE_VOICE_API_URL ?? '').trim().replace(/\/+$/, '');
    if (voiceApi) {
      const response = await fetch(`${voiceApi}/v1/recipes/transcribe`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(input),
      });
      const payload = await response.json() as { text?: string; error?: { message?: string } };
      if (!response.ok || !payload.text) {
        throw new ApiError(
          'INTERNAL',
          payload.error?.message ?? 'No he podido escuchar la grabación.',
          response.status,
        );
      }
      return { text: payload.text };
    }
    await new Promise((resolve) => setTimeout(resolve, 700));
    return {
      text: 'Tacos de camarón, salen 3 por porción: 120 gramos de camarón, 3 tortillas de maíz y 30 gramos de crema de chipotle. Los vendo a 145.',
    };
  },

  async adminGrowthTarget() { return { monthly: 0 }; },
  async adminSaveGrowthTarget(monthly) { return { monthly }; },
  async getMe(): Promise<MeResponse> {
    // La demo es el escaparate para restauradores: el panel de plataforma
    // (clientes, MRR) es informacion NUESTRA y no pinta nada aqui.
    return {
      // «Alexia tiene nueva cara»: la misma regla que la API (cuenta anterior
      // al corte), pero solo con `?novedades=1` para no tapar los smokes.
      user: { ...state.user, novedades: demoConNovedades() && teniaCuentaAntesDeNovedades(state.user.createdAt) },
      tenant: state.tenant,
      memberships: [state.user],
      locations: localesQueVe(todosLosLocales(), state.user.role === 'owner' ? undefined : state.user.locationIds),
    };
  },

  async listLocations() {
    return todosLosLocales();
  },
  async createLocation(name: string) {
    // Como la API: el límite del plan (los locales de cortesía cuentan).
    const activos = todosLosLocales().filter((l) => l.active).length;
    const limite = locationLimitOf(state.tenant);
    if (activos >= limite) {
      throw new ApiError('PLAN_LIMIT', `Tienes ${limite === 1 ? '1 centro incluido' : `${limite} centros contratados`}. Amplía los centros desde Configuración para agregar otro.`, 402);
    }
    const local: LocalDemo = { tenantId: TENANT_ID, locationId: newId('loc'), name: name.trim(), active: true };
    demoOtrosLocales = [...demoOtrosLocales, local];
    return local;
  },
  async updateLocation(locationId, input) {
    if (locationId === demoLocation.locationId) {
      demoLocation = { ...demoLocation, ...input };
      return demoLocation;
    }
    const actual = demoOtrosLocales.find((l) => l.locationId === locationId);
    if (!actual) throw notFound('ese local');
    const nuevo = { ...actual, ...input };
    demoOtrosLocales = demoOtrosLocales.map((l) => (l.locationId === locationId ? nuevo : l));
    return nuevo;
  },
  /** Espejo de PATCH /v1/locations/:id/config (bloque C). */
  async updateLocationConfig(locationId, patch) {
    const actual = todosLosLocales().find((l) => l.locationId === locationId);
    if (!actual) throw notFound('ese local');
    const next: LocalDemo = { ...actual };
    if (patch.closedWeekdays !== undefined) {
      next.closedWeekdays = [...patch.closedWeekdays].sort();
      next.operatingWeekdays = diasQueAbre(patch.closedWeekdays);
    }
    if (patch.sales !== undefined) {
      if (patch.sales === null) delete next.sales;
      else next.sales = { ...(actual.sales ?? {}), ...patch.sales };
    }
    if (patch.currency !== undefined) {
      if (patch.currency === null) delete next.currency;
      else next.currency = patch.currency;
    }
    if (locationId === demoLocation.locationId) demoLocation = next;
    else demoOtrosLocales = demoOtrosLocales.map((l) => (l.locationId === locationId ? next : l));
    return clone(next);
  },
  async setMemberLocations(userId) {
    if (userId === state.user.userId) throw new ApiError('VALIDATION_ERROR', 'El dueño ve siempre todos los locales.', 400);
    throw new ApiError('NOT_FOUND', 'Esa persona no forma parte del equipo.', 404);
  },
  async updateMyName(name) {
    state.user = { ...state.user, name: name.trim() };
    return { name: name.trim() };
  },
  /** Espejo de PUT /v1/me con `apariencia`: se guarda en la persona. */
  async updateMyAppearance(apariencia) {
    if (!['auto', 'claro', 'oscuro'].includes(apariencia)) throw new ApiError('VALIDATION_ERROR', 'Apariencia no válida.', 400);
    state.user = { ...state.user, apariencia };
    return { apariencia };
  },
  /** Espejo de POST /v1/tenants/current/deletion: en la demo no se borra nada de verdad. */
  async requestAccountDeletion(confirmName) {
    // Como la API: solo el dueño (un administrador no).
    if (state.user.role !== 'owner') throw new ApiError('FORBIDDEN', 'No tienes permisos suficientes para esta operación. Pide acceso al propietario.', 403);
    if (state.tenant.deletion) return clone(state.tenant);
    if (!confirmaNombre(confirmName, state.tenant.name)) {
      throw new ApiError('VALIDATION_ERROR', `Escribe el nombre de tu restaurante tal cual: «${state.tenant.name}».`, 400);
    }
    const ahora = new Date();
    state.tenant = { ...state.tenant, deletion: { requestedAt: ahora.toISOString(), scheduledFor: fechaDeBorrado(ahora), requestedBy: state.user.userId, requestedByEmail: state.user.email, motivo: 'pedido' } };
    return clone(state.tenant);
  },
  /** Espejo de GET /v1/assistant/usage: la demo no gasta preguntas de verdad. */
  async getAssistantUsage() {
    return usageStatus(state.tenant.plan, { month: currentMonthDemo(), messages: 0, estimatedCost: 0 });
  },
  async cancelAccountDeletion() {
    if (state.user.role !== 'owner') throw new ApiError('FORBIDDEN', 'No tienes permisos suficientes para esta operación. Pide acceso al propietario.', 403);
    // Como la API (retención de 12 meses sin plan): no se cancela con «No borrar», sino eligiendo un plan.
    if (state.tenant.deletion?.motivo === 'retencion') throw new ApiError('VALIDATION_ERROR', 'Para conservar tus datos, elige un plan.', 400);
    const { deletion: _quitar, ...resto } = state.tenant;
    state.tenant = resto as Tenant;
    return clone(state.tenant);
  },

  /** Espejo de POST /v1/tenants/current/timezone: solo si falta y es una zona de verdad. */
  async fillMissingTimezone(timezone: string) {
    if (!state.tenant.timezone && zonaDelNavegadorAprovechable(timezone)) state.tenant = { ...state.tenant, timezone };
    return { timezone: state.tenant.timezone ?? null };
  },

  async updateTenant(patch: TenantUpdate): Promise<Tenant> {
    const { setup, ...resto } = patch;
    state.tenant = { ...state.tenant, ...resto };
    // Igual que la API: un WhatsApp vacio se borra, no se guarda "".
    if (!state.tenant.whatsapp?.trim()) delete state.tenant.whatsapp;
    // Cuestionario inicial: en la demo se puede repetir desde Ayuda y Alex
    // lo graba asi. Misma regla que el servidor: completed pone la fecha.
    if (setup) {
      state.tenant.setup = setup.completed
        ? { step: setup.step, firstRecipeId: setup.firstRecipeId ?? state.tenant.setup?.firstRecipeId, recipeFirstPending: false, completedAt: new Date().toISOString() }
        : { step: setup.step, firstRecipeId: setup.firstRecipeId ?? state.tenant.setup?.firstRecipeId, recipeFirstPending: setup.recipeFirstPending ?? state.tenant.setup?.recipeFirstPending };
    }
    return state.tenant;
  },

  async markAvisoVisto(id: string) {
    // Igual que la API: por persona, sin repetir.
    const avisosVistos = conAvisoVisto(state.user.avisosVistos, id);
    state.user = { ...state.user, avisosVistos };
    // La API lo guarda en la membresía y sobrevive a recargar; la demo vive
    // en memoria, así que el de novedades se apunta en la pestaña.
    if (id === NOVEDADES_ID) { try { sessionStorage.setItem(CLAVE_DEMO_NOVEDADES_VISTO, '1'); } catch { /* sin almacenamiento */ } }
    return { avisosVistos };
  },
  async marcarPrimerosPasos(input) {
    let estado = state.tenant.primerosPasos ?? {};
    if (input.hecho) estado = conTareaHecha(estado, input.hecho);
    if (input.terminado && !estado.terminadoAt) estado = { ...estado, terminadoAt: new Date().toISOString() };
    state.tenant = { ...state.tenant, primerosPasos: estado };
    return estado;
  },

  async markTourSeen() {
    const tourSeenAt = new Date().toISOString();
    state.user = { ...state.user, tourSeenAt };
    return { tourSeenAt };
  },

  /* --- Ajustes --- */

  async exportBusiness(): Promise<Record<string, object[]>> {
    return clone({Ingredientes:state.ingredients, Recetas:state.recipes, Carta:state.menuItems, Proveedores:state.suppliers, Ingresos:state.revenues, Gastos:state.expenses, Inversiones:state.investments, Tesorería:state.cashMovements, Inventarios:state.inventoryCounts, Objetivos:state.targets, Configuración:[state.settings], Locales:[{locationId:'principal', name:'Principal', active:true}], Restaurante:[{nombre:state.tenant.name, moneda:state.tenant.currency, país:state.tenant.country, datosFiscales:state.tenant.tax}]});
  },
  async getSettings(): Promise<TenantSettings> {
    return clone(state.settings);
  },

  async updateSettings(input: TenantSettings): Promise<TenantSettings> {
    // Igual que la API: el colchón de la cuenta pasa a las recetas que lo siguen.
    const antes = colchonDeCuenta(state.settings);
    const ahora = colchonDeCuenta(input);
    // Como la API: las recetas viejas (sin marca) solo si tenían el de la cuenta.
    if (ahora !== antes) state.recipes = state.recipes.map((r) => (sigueColchonDeCuenta(r, antes) ? { ...r, safetyMarginPct: ahora, safetyMarginCustom: false } : r));
    state.settings = clone(input);
    state.tenant = { ...state.tenant, settings: state.settings };
    return clone(state.settings);
  },

  /* --- Integraciones con TPV: la demo no se conecta con nada --- */

  async listPosIntegrations(): Promise<PosIntegrationsResponse> {
    const none = { oauth: false, token: false };
    return { items: clone(demoPos), providers: { loyverse: { oauth: true, token: true }, square: { oauth: true, token: false }, revo: none, glop: { oauth: false, token: true }, lastapp: none, restaurantpe: { oauth: false, token: true }, bistrosoft: { oauth: false, token: true }, polotab: { oauth: false, token: true }, sumup: { oauth: false, token: true } } };
  },
  async startPosConnection(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'La demo no se conecta con ningún punto de venta. Crea tu cuenta para conectar el tuyo.', 403);
  },
  async completePosConnection(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'La demo no se conecta con ningún punto de venta.', 403);
  },
  async connectLoyverseToken(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'La demo no se conecta con ningún punto de venta. Crea tu cuenta para conectar el tuyo.', 403);
  },
  async connectGlopCredentials(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'La demo no se conecta con ningún punto de venta. Crea tu cuenta para conectar el tuyo.', 403);
  },
  async connectRestaurantPeCredentials(): Promise<never> { throw new Error('La demo no admite conexiones con punto de venta.'); },
  async connectPosCredentials(): Promise<never> { throw new Error('La demo no admite conexiones con punto de venta.'); },
  async connectLastAppAccount(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'La demo no se conecta con ningún punto de venta. Crea tu cuenta para conectar el tuyo.', 403);
  },
  /** Espejo de PUT /v1/integrations/pos/:provider/:connectionId (tiendas → locales y día de negocio). */
  async updatePosIntegration(provider, connectionId, patch): Promise<import('@alexiarest/shared').PosIntegrationView> {
    const actual = demoPos.find((i) => i.provider === provider && i.connectionId === connectionId);
    if (!actual) throw new ApiError('NOT_FOUND', 'Este punto de venta no está conectado.', 404);
    const validos = new Set(todosLosLocales().filter((l) => l.active).map((l) => l.locationId));
    if (patch.stores?.some((st) => st.locationId !== null && !validos.has(st.locationId))) {
      throw new ApiError('VALIDATION_ERROR', 'Uno de los locales indicados no existe o está desactivado.', 400);
    }
    const quiere = new Map((patch.stores ?? []).map((st) => [st.externalId, st.locationId]));
    const next = {
      ...actual,
      stores: actual.stores.map((st) => (quiere.has(st.externalId) ? { ...st, locationId: quiere.get(st.externalId) ?? null } : st)),
      ...(patch.timezone !== undefined ? { timezone: patch.timezone } : {}),
      ...(patch.businessDayStartHour !== undefined ? { businessDayStartHour: patch.businessDayStartHour } : {}),
    };
    demoPos = demoPos.map((i) => (i === actual ? next : i));
    return clone(next);
  },
  async syncPosSales(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'En la demo las ventas ya vienen anotadas: no se traen del punto de venta.', 403);
  },
  async applyPosUnits(): Promise<never> {
    throw new ApiError('NOT_FOUND', 'En la demo no hay ningún punto de venta conectado.', 404);
  },
  /** Espejo de DELETE /v1/integrations/pos/:provider/:connectionId[?locationId=]. */
  async disconnectPos(provider, connectionId, locationId): Promise<void> {
    const actual = demoPos.find((i) => i.provider === provider && i.connectionId === connectionId);
    if (!actual) throw new ApiError('NOT_FOUND', 'Este punto de venta no está conectado.', 404);
    if (locationId && actual.stores.some((st) => st.locationId !== null && st.locationId !== locationId)) {
      const next = { ...actual, stores: actual.stores.map((st) => (st.locationId === locationId ? { ...st, locationId: null } : st)) };
      demoPos = demoPos.map((i) => (i === actual ? next : i));
      return;
    }
    demoPos = demoPos.filter((i) => i !== actual);
  },

  /* --- Ingredientes --- */

  async listInbox() {
    return clone(inbox.map((entry) => ({ ...entry, cards: entry.cards.map((card) => ({ ...card, draft: drafts.find((d) => d.id === card.draft.id) ?? card.draft })) })));
  },
  // Igual que la API: los mensajes que aún se preparan se quedan, salvo los ya caducados.
  async clearInbox() { inbox = inbox.filter((entry) => entry.reply === undefined && entry.expiresAt > Date.now() / 1000); },
  async sendInbox(input) {
    const previous = (await this.listInbox()).find((entry) => entry.id === input.id);
    if (previous) return previous;
    // La demo usa ejemplos locales; nunca envía el texto a un servicio externo.
    // Una pregunta (o algo que no parece una receta ni un gasto) se responde
    // con el mismo motor determinista que el panel de ayuda: datos reales
    // del dataset, sin modelo detrás. Lo demás se enseña con el risotto.
    const pregunta = !input.draftIds && !input.replyToDraftId && /[¿?]|^(qué|que|cómo|como|cuánto|cuanto|dónde|donde|por qué|porque|analiza|dime|explíca|explica)\b/i.test(input.text.trim());
    if (pregunta) {
      await pause(400);
      const answer = demoChat(assistantData(), input.text, input.period ?? demoPeriod, todayIso());
      const entry: InboxEntry = { ...input, createdAt: new Date().toISOString(), expiresAt: Math.floor(Date.now() / 1000) + DRAFT_TTL_SECONDS, reply: answer.reply, replyKind: 'analysis', toolCalls: answer.toolCalls, cards: [] };
      inbox.push(entry); return clone(entry);
    }
    const ids = input.draftIds ?? [(await this.createRecipeDraft(structuredClone(DEMO_MX_RECIPE_PROPOSAL))).id];
    const cards = await Promise.all(ids.map(async (id) => {
      const draft = await this.getDraft(id);
      const preview = draft.kind === 'recipe' ? previewDemoRecipe(draft.payload) : undefined;
      const money = (n: number) => formatMoneyIn(n, state.tenant.currency);
      const text = draft.kind === 'recipe' ? `${draft.payload.name} · ${draft.payload.servings} porciones · ${draft.payload.lines.length} ingredientes.${preview?.cost ? ` Costo por porción ${preview.cost.costEstimated ? '~' : ''}${money(preview.cost.costPerPortion)}${preview.cost.costEstimated ? ' (estimado)' : ''}.` : ''}` : draft.kind === 'expense' ? `${draft.summary} · Base ${money(draft.payload.proposal.netAmount)} + IVA ${ivaEnFrase(draft.payload.proposal)}.` : draft.summary;
      return { draft, text };
    }));
    const entry: InboxEntry = { ...input, draftIds: ids, createdAt: new Date().toISOString(), expiresAt: Math.floor(Date.now() / 1000) + DRAFT_TTL_SECONDS, reply: input.fileName ? 'Preparé estas propuestas de ejemplo. Confirma el gasto y los precios por separado.' : 'En esta demo te muestro un risotto de ejemplo. En tu restaurante interpretaré lo que me cuentes.', replyKind: 'proposals', cards };
    inbox.push(entry); return clone(entry);
  },
  async listDrafts(locationId) {
    return clone(drafts.filter((draft) => draft.status === 'pending' && !draftIsExpired(draft) && (!locationId || (draft.locationId ?? 'principal') === locationId)));
  },
  async getDraft(id) {
    const draft = drafts.find((item) => item.id === id);
    if (!draft) throw notFound('ese borrador');
    if (draft.status === 'pending' && draftIsExpired(draft)) throw new ApiError('GONE', 'El borrador caducó.', 410);
    return clone(draft);
  },
  async createRecipeDraft(payload) {
    const now = new Date();
    const draft: Draft = { id: newId('draft'), tenantId: TENANT_ID, kind: 'recipe', source: 'demo', status: 'pending', payload: clone(payload), summary: payload.name, createdBy: { userSub: state.user.userId }, createdAt: now.toISOString(), expiresAt: Math.floor(now.getTime() / 1000) + DRAFT_TTL_SECONDS };
    drafts.push(draft);
    return clone(draft);
  },
  async createDraftLink(id) {
    await this.getDraft(id);
    const token = newId('link');
    const expiresAt = Math.floor(Date.now() / 1000) + 900;
    draftLinks.set(token, { id, expiresAt });
    return { url: `${window.location.origin}/borradores/${id}?token=${token}`, expiresAt };
  },
  async redeemDraftLink(id, token) {
    const link = draftLinks.get(token);
    if (!link || link.id !== id || link.expiresAt <= Date.now() / 1000) throw new ApiError('GONE', 'El enlace caducó o ya se usó.', 410);
    draftLinks.delete(token);
    return { redeemed: true };
  },
  async discardDraft(id) {
    const draft = await this.getDraft(id);
    if (draft.status === 'confirmed') throw new ApiError('CONFLICT', 'El borrador ya se confirmó.', 409);
    const discarded = { ...draft, status: 'discarded' as const };
    drafts = drafts.map((item) => item.id === id ? discarded : item);
    return clone(discarded);
  },
  /* --- Bloque S · escáner único: lo mismo que la API (routes/drafts.ts) --- */
  async listPorRevisar(locationId) {
    const pendientes = drafts.filter((d) => d.status === 'pending' && !draftIsExpired(d) && (d.kind === 'expense' || d.kind === 'catalog-prices') && (!locationId || (d.locationId ?? 'principal') === locationId));
    const ctx = contextoEscanerDemo();
    const filas = filasPorRevisar(pendientes, ctx);
    const disponible = guardarLasNDisponible(state.tenant.createdAt, ctx.hoy, demoScanStats);
    const ids = filas.filter((f) => f.todoClaro && f.expenseDraftId).map((f) => f.expenseDraftId!);
    return clone({ filas, guardarLasN: { visible: disponible.visible && ids.length > 0, ids, ...(disponible.motivo ? { motivo: disponible.motivo } : {}) } });
  },
  async guardarTodoClaro(ids) {
    if (!guardarLasNDisponible(state.tenant.createdAt, todayIso(), demoScanStats).visible) throw new ApiError('FORBIDDEN', '«Guardar las N» todavía no está disponible en tu cuenta: revisa cada factura.', 403);
    const guardadas: string[] = [];
    const saltadas: string[] = [];
    for (const id of ids) {
      const g = drafts.find((d): d is Extract<Draft, { kind: 'expense' }> => d.id === id && d.kind === 'expense' && d.status === 'pending');
      if (!g) { saltadas.push(id); continue; }
      const clave = g.inputKey;
      const p = clave ? drafts.find((d): d is Extract<Draft, { kind: 'catalog-prices' }> => d.kind === 'catalog-prices' && d.status === 'pending' && d.inputKey === clave) : undefined;
      const ctx = contextoEscanerDemo();
      const proposal = g.payload.proposal;
      if (motivosParaRevisar(proposal, g.payload.documentType, p?.payload, ctx, { requiresReview: g.payload.requiresReview }).length > 0
        || notasSinFacturaDe(proposal.supplierId, ctx.expenses) > 0) { saltadas.push(id); continue; }
      const preciosAntes: NonNullable<NonNullable<Draft['result']>['preciosAntes']> = [];
      for (const line of p?.payload.lines ?? []) {
        if (line.action === 'ignore' || line.match.kind !== 'exact' || !line.comparison) continue;
        const ing = state.ingredients.find((i) => i.ingredientId === line.match.candidates[0]?.ingredientId);
        if (!ing || !(ing.netPrice! > 0) || !ing.purchaseQty || !ing.purchaseUnit) continue;
        if (Math.abs(line.comparison.changePct) <= REGLAS_ESCANER.umbralIgualPct) { await this.confirmIngredientPrice(ing.ingredientId); continue; }
        const nuevo = precioDePresentacion(ing.netPrice!, line.comparison);
        preciosAntes.push({ ingredientId: ing.ingredientId, netPrice: ing.netPrice, purchaseQty: ing.purchaseQty, purchaseUnit: ing.purchaseUnit, puesto: nuevo });
        await this.importIngredients({ items: [{ id: ing.ingredientId, input: catalogPriceInput(ing, ing.name, nuevo, ing.purchaseQty, ing.purchaseUnit as UnidadDeCompra) }] });
      }
      const vence = vencimientoDe(proposal, ctx);
      const supplier = state.suppliers.find((s) => s.supplierId === proposal.supplierId);
      const saved = await this.createExpense(gastoDesdeEscaneo(proposal, { documentType: g.payload.documentType, paid: vence.dueDate ? false : proposal.paid, dueDate: vence.dueDate, concept: supplier?.name }));
      const ahora = new Date().toISOString();
      state.expenses = state.expenses.map((e) => (e.entryId === saved.entryId ? { ...e, guardadaSinRevisar: ahora } : e));
      drafts = drafts.map((d) => d.id === g.id ? { ...g, status: 'confirmed' as const, confirmedAt: ahora, result: { expenseId: saved.entryId, preciosAntes } }
        : p && d.id === p.id ? { ...p, status: 'confirmed' as const, confirmedAt: ahora, result: { expenseId: saved.entryId } } : d);
      demoScanStats.guardadasSinRevisar += 1;
      guardadas.push(id);
    }
    return { guardadas, saltadas };
  },
  async deshacerSinRevisar(expenseId) {
    const expense = state.expenses.find((e) => e.entryId === expenseId);
    if (!expense) throw notFound('ese gasto');
    if (!expense.guardadaSinRevisar) throw new ApiError('VALIDATION_ERROR', 'Este gasto no se guardó sin revisar.', 400);
    // Como la API: lo que impide borrarlo se mira antes de devolver los precios.
    if (expense.reconciledInvoiceId || expense.deliveryNoteIds?.length) {
      throw new ApiError('VALIDATION_ERROR', 'Esta factura ya está juntada con sus notas: sepáralas antes de deshacerla.', 400);
    }
    const suyos = drafts.filter((d) => d.result?.expenseId === expenseId);
    const g = suyos.find((d) => d.kind === 'expense');
    for (const antes of g?.result?.preciosAntes ?? []) {
      const ing = state.ingredients.find((i) => i.ingredientId === antes.ingredientId);
      if (!ing || antes.puesto == null || antes.netPrice == null || !antes.purchaseQty || !antes.purchaseUnit) continue;
      if (Math.abs((ing.netPrice ?? 0) - antes.puesto) > 1e-6) continue;
      await this.importIngredients({ items: [{ id: ing.ingredientId, input: catalogPriceInput(ing, ing.name, antes.netPrice, antes.purchaseQty, antes.purchaseUnit as UnidadDeCompra) }] });
    }
    await this.deleteExpense(expenseId);
    const vence = Math.floor(Date.now() / 1000) + DEMO_SCAN_TTL_SECONDS;
    drafts = drafts.map((d) => (d.result?.expenseId === expenseId ? { ...d, status: 'pending' as const, confirmedAt: undefined, result: undefined, expiresAt: vence } : d));
    demoScanStats.deshechas += 1;
    return { deshecha: true, borradores: suyos.map((d) => d.id) };
  },
  async dejarLineasPorDecidir(draftId, quedan, factura) {
    const draft = await this.getDraft(draftId);
    if (draft.kind !== 'catalog-prices') throw new ApiError('VALIDATION_ERROR', 'Solo los precios de una factura se quedan a medias.', 400);
    if (draft.status !== 'pending') return draft;
    const lines = draft.payload.lines.filter((l) => quedan.includes(l.index));
    const next: Draft = lines.some((l) => l.action !== 'ignore')
      ? { ...draft, payload: { ...draft.payload, lines, ...(factura ? { factura } : {}) } }
      : { ...draft, status: 'confirmed', confirmedAt: new Date().toISOString(), result: { ...(factura?.expenseId ? { expenseId: factura.expenseId } : {}) } };
    drafts = drafts.map((d) => (d.id === draftId ? next : d));
    return clone(next);
  },
  async confirmDraft(id, patch = {}) {
    const running = confirmingDrafts.get(id);
    if (running) return running;
    const task = (async () => {
      const draft = await this.getDraft(id);
      if (draft.status === 'confirmed') return draft;
      if (draft.status !== 'pending') throw new ApiError('CONFLICT', 'El borrador ya está descartado.', 409);
      let result: Draft['result'];
      if (draft.kind === 'recipe') {
        const input = patch.recipe ?? { ...draft.payload, servings: draft.payload.servings ?? 1, lines: draft.payload.lines.map((line) => {
          const matches = line.isSubrecipe ? state.recipes.filter((recipe) => normalizeIngredientName(recipe.name) === normalizeIngredientName(line.ingredientName)) : [];
          if (line.isSubrecipe && matches.length !== 1) throw new Error('Revisa la preparación en la app.');
          return { ingredientName: line.ingredientName, ingredientId: line.ingredientId, recipeId: matches[0]?.recipeId, qty: line.qty ?? 0, unit: line.unit ?? 'g', wastePct: line.wastePct ?? 0 };
        }) };
        const saved = await this.confirmRecipeProposal(input);
        result = { recipeId: saved.recipe.recipeId, ingredientIds: saved.newIngredients.map((item) => item.ingredientId) };
      } else if (draft.kind === 'expense') {
        if (draft.payload.proposal.duplicado && !patch.acceptPossibleDuplicate) throw new ApiError('CONFLICT', 'La factura ya está guardada.', 409);
        const base = patch.expense ?? draft.payload.input ?? { ...draft.payload.proposal, notes: draft.payload.proposal.vatNote };
        // Como la API: si el proveedor se unió a otro mientras tanto, va al que se quedó.
        const input = base.supplierId ? { ...base, supplierId: proveedorVigente(base.supplierId) } : base;
        if (!patch.acceptPossibleDuplicate && buscarDuplicado(input, state.expenses, draft.payload.documentType ?? 'factura')) throw new Error('Esta factura ya está guardada. Revísala antes de confirmar.');
        const saved = await this.createExpense(input);
        result = { expenseId: saved.entryId };
      } else if (draft.kind === 'catalog-prices') {
        if (!patch.prices && draft.payload.lines.some((line) => line.action === 'choose')) throw new Error('Revisa las coincidencias dudosas.');
        const prices = patch.prices ?? draft.payload.lines.filter((line) => line.action !== 'ignore').map((line) => ({ ingredientId: ['exact', 'fuzzy'].includes(line.match.kind) ? line.match.candidates[0]?.ingredientId : undefined, name: line.name, price: line.unitPrice!, qty: 1, unit: purchaseUnitSchema.parse(line.unit) }));
        if (!prices.length) throw new Error('No hay precios para confirmar.');
        const batch = { items: prices.map((row) => {
          const current = state.ingredients.find((item) => item.ingredientId === row.ingredientId);
          if (!current && (row.ingredientId || !('createNew' in row) || !row.createNew)) throw new Error('Elige un ingrediente existente o confirma la creación.');
          const input = { ...catalogPriceInput(current, current?.name ?? row.name, row.price, row.qty, row.unit), ...(!current && 'createNew' in row ? { presentation: row.presentation, supplierId: proveedorVigente(row.supplierId) ?? row.supplierId } : {}) };
          if (!current && state.ingredients.some(ing => invoiceIngredientKey(ing) === invoiceIngredientKey(input))) throw new Error('Este ingrediente y formato ya existen. Selecciónalo para actualizar su precio.');
          return { id: current?.ingredientId, input };
        }) };
        const saved = await this.importIngredients(batch);
        if (saved.errores.length) throw new ApiError('VALIDATION_ERROR', saved.errores.map((error) => error.message).join(' · '), 400);
        result = {};
      } else throw new ApiError('VALIDATION_ERROR', 'Revisa los precios antes de guardar.', 400);
      const confirmed = { ...draft, status: 'confirmed' as const, confirmedAt: new Date().toISOString(), result };
      drafts = drafts.map((item) => item.id === id ? confirmed : item);
      return clone(confirmed);
    })();
    confirmingDrafts.set(id, task);
    try { return await task; } finally { confirmingDrafts.delete(id); }
  },

  async estimateMissingPrices() {
    let estimated = 0;
    const errors: Array<{ ingredientId: string; message: string }> = [];
    state.ingredients = state.ingredients.map((item) => {
      if (netPriceOf(item) || item.priceEstimated) return item;
      const priceEstimated = item.purchaseUnit ? demoPriceEstimate(item.name, item.purchaseUnit, state.tenant.country, state.tenant.currency) : null;
      if (!priceEstimated) { errors.push({ ingredientId: item.ingredientId, message: 'Sin estimación disponible. Completa este precio.' }); return item; }
      estimated += 1;
      return { ...item, priceEstimated, pricePending: true };
    });
    return { estimated, remaining: errors.length, errors };
  },

  async listPresentations() { return clone(purchasePresentations); },
  async createPresentation(name: string) {
    const normalized = name.normalize('NFC').trim();
    if (!normalized || normalized.length > 120) throw new Error('La presentación debe tener entre 1 y 120 caracteres.');
    const values = purchasePresentations;
    const existing = values.find(value => value.toLocaleLowerCase('es') === normalized.toLocaleLowerCase('es'));
    if (existing) return { name: existing };
    purchasePresentations = [...values, normalized];
    return { name: normalized };
  },
  async listIngredients(): Promise<Ingredient[]> {
    return [...state.ingredients].sort((a, b) => a.name.localeCompare(b.name, 'es'));
  },

  async createIngredient(input: IngredientInput): Promise<Ingredient> {
    const { priceConfirmed: _priceConfirmed, ...fields } = input;
    const now = new Date().toISOString();
    const created: Ingredient = {
      ...fields,
      tenantId: TENANT_ID,
      pricePending: input.netPrice == null,
      priceEstimated: input.netPrice == null && input.purchaseUnit ? demoPriceEstimate(input.name, input.purchaseUnit, state.tenant.country, state.tenant.currency) ?? undefined : undefined,
      ingredientId: newId('ing'),
      updatedAt: now,
      priceUpdatedAt: input.netPrice != null ? now : undefined,
    };
    state.ingredients = [...state.ingredients, created];
    return created;
  },

  async updateIngredient(id: string, input: IngredientInput): Promise<Ingredient> {
    const current = state.ingredients.find((i) => i.ingredientId === id);
    if (!current) throw notFound('ese ingrediente');
    // Igual que la API: cambiar precio o formato, una factura o confirmarlo.
    const { priceConfirmed, ...fields } = input;
    const now = new Date().toISOString();
    const priceChanged = input.netPrice !== netPriceOf(current)
      || (input.purchaseQty ?? 1) !== (current.purchaseQty ?? 1)
      || (input.purchaseUnit ?? 'kg') !== (current.purchaseUnit ?? 'kg')
      || input.priceSource === 'factura'
      || Boolean(current.pricePending);
    const updated: Ingredient = {
      ...current,
      ...fields,
      pricePending: input.netPrice == null,
      priceEstimated: current.priceEstimated,
      allergens: input.allergens ?? current.allergens,
      priceSource: input.priceSource ?? (input.netPrice !== current.netPrice ? 'manual' : current.priceSource),
      ingredientId: id,
      tenantId: TENANT_ID,
      updatedAt: now,
      priceUpdatedAt: input.netPrice == null ? undefined
        : priceChanged || priceConfirmed ? now : current.priceUpdatedAt,
    };
    state.ingredients = state.ingredients.map((i) => (i.ingredientId === id ? updated : i));
    return updated;
  },

  async renameIngredient(id: string, name: string): Promise<Ingredient> {
    const current = state.ingredients.find(i => i.ingredientId === id);
    if (!current) throw notFound('ese ingrediente');
    const updated = { ...current, name: name.trim(), updatedAt: new Date().toISOString() };
    state.ingredients = state.ingredients.map(i => i.ingredientId === id ? updated : i);
    return updated;
  },

  async confirmIngredientPrice(id: string): Promise<Ingredient> {
    const current = state.ingredients.find((i) => i.ingredientId === id);
    if (!current) throw notFound('ese ingrediente');
    if (current.netPrice == null && !current.prices?.length) throw new ApiError('VALIDATION_ERROR', 'Este ingrediente aún no tiene precio: escríbelo para confirmarlo.', 400);
    const updated = { ...current, priceUpdatedAt: new Date().toISOString() };
    state.ingredients = state.ingredients.map((i) => (i.ingredientId === id ? updated : i));
    return updated;
  },

  async deleteIngredient(id: string): Promise<void> {
    // Misma red y mismo mensaje que la API: shared/recipeUsage.ts.
    const aviso = ingredientUsageMessage(ingredientUsage(id, state.recipes));
    if (aviso) throw new ApiError('CONFLICT', aviso, 409);
    state.ingredients = state.ingredients.filter((i) => i.ingredientId !== id);
  },

  /* --- Fase 7 · alias y «No es un ingrediente» (mismas reglas que la API) --- */

  async rememberIngredientAliases(entrada) {
    // Como la API: el texto se recorta a 120 en vez de rechazarse.
    const items = entrada.map((item) => ({ ...item, text: item.text.trim().slice(0, 120).trim() })).filter((item) => item.text);
    const cambiados = new Map<string, Ingredient>();
    const actual = (id: string) => cambiados.get(id) ?? state.ingredients.find((i) => i.ingredientId === id);
    const now = new Date().toISOString();
    for (const item of items) {
      const target = actual(item.ingredientId);
      if (!target) throw notFound('ese ingrediente');
      const vistos = state.ingredients.map((i) => actual(i.ingredientId)!);
      for (const otro of ingredientsWithAlias(vistos, item.text, item.supplierId)) {
        if (otro.ingredientId !== target.ingredientId) cambiados.set(otro.ingredientId, { ...otro, aliases: withoutAlias(otro.aliases, item.text, item.supplierId ?? null) });
      }
      const aliases = withAlias(target, { text: item.text, supplierId: item.supplierId, source: item.source, createdAt: now });
      if (JSON.stringify(aliases) !== JSON.stringify(target.aliases ?? [])) cambiados.set(target.ingredientId, { ...target, aliases });
    }
    state.ingredients = state.ingredients.map((i) => cambiados.get(i.ingredientId) ?? i);
    return { items: clone([...cambiados.values()]) };
  },

  async forgetIngredientAlias(id, text, supplierId) {
    const current = state.ingredients.find((i) => i.ingredientId === id);
    if (!current) throw notFound('ese ingrediente');
    const updated = { ...current, aliases: withoutAlias(current.aliases, text, supplierId ?? null) };
    state.ingredients = state.ingredients.map((i) => (i.ingredientId === id ? updated : i));
    return clone(updated);
  },

  async listNoIngredientLines() { return clone(noIngredientRules); },

  async updateNoIngredientLines(change) {
    const clave = (r: { text: string; supplierId?: string }) => `${r.supplierId || '-'}#${aliasKey(r.text)}`;
    // Como la API: el texto se recorta a 120 antes de nada (también al quitar).
    const recorta = <T extends { text: string }>(r: T): T => ({ ...r, text: r.text.trim().slice(0, 120).trim() });
    const add = (change.add ?? []).map(recorta).filter((r) => aliasKey(r.text));
    const fuera = new Set([...add, ...(change.remove ?? []).map(recorta)].map(clave));
    const now = new Date().toISOString();
    noIngredientRules = [
      ...noIngredientRules.filter((r) => !fuera.has(clave(r))),
      ...add.map((r) => ({ text: r.text.trim().slice(0, 120), ...(r.supplierId ? { supplierId: r.supplierId } : {}), createdAt: now })),
    ].slice(-500);
    return { items: clone(noIngredientRules) };
  },

  /* --- Proveedores --- */

  async listSuppliers(): Promise<Supplier[]> {
    return [...state.suppliers];
  },

  /* Espejo de packages/api/src/repositories/suppliers.ts (fase 7). */
  async createSupplier(input: SupplierInput): Promise<Supplier> {
    const parsed = supplierInputSchema.safeParse(input);
    if (!parsed.success) throw new ApiError('VALIDATION_ERROR', parsed.error.issues[0]?.message ?? 'Revisa el proveedor.', 400);
    const created = nuevoProveedor(TENANT_ID, newId('sup'), parsed.data);
    state.suppliers = [...state.suppliers, created];
    return created;
  },

  async updateSupplier(id: string, input: SupplierInput): Promise<Supplier> {
    const current = state.suppliers.find((s) => s.supplierId === id);
    if (!current) throw notFound('ese proveedor');
    const parsed = supplierInputSchema.safeParse(input);
    if (!parsed.success) throw new ApiError('VALIDATION_ERROR', parsed.error.issues[0]?.message ?? 'Revisa el proveedor.', 400);
    const updated = aplicarEdicionProveedor(current, parsed.data);
    state.suppliers = state.suppliers.map((s) => (s.supplierId === id ? updated : s));
    return updated;
  },

  async deleteSupplier(id: string): Promise<void> {
    const enUso = state.ingredients.filter((i) => i.supplierId === id).length;
    if (enUso > 0) {
      throw new ApiError('VALIDATION_ERROR', `No puedes borrar este proveedor: está asignado a ${enUso} ${enUso === 1 ? 'ingrediente' : 'ingredientes'}. Archívalo o únelo con otro.`, 400);
    }
    const conGastos = state.expenses.filter((e) => e.supplierId === id).length;
    if (conGastos > 0) {
      throw new ApiError('VALIDATION_ERROR', `No puedes borrar este proveedor: tiene ${conGastos} ${conGastos === 1 ? 'gasto registrado' : 'gastos registrados'}. Archívalo o únelo con otro.`, 400);
    }
    state.suppliers = state.suppliers.filter((s) => s.supplierId !== id);
  },

  async archiveSupplier(id: string, archived: boolean): Promise<Supplier> {
    const current = state.suppliers.find((s) => s.supplierId === id);
    if (!current) throw notFound('ese proveedor');
    const { archived: _a, ...rest } = current;
    const next: Supplier = archived ? { ...rest, archived: true } : rest;
    state.suppliers = state.suppliers.map((s) => (s.supplierId === id ? next : s));
    return next;
  },

  async markSuppliersDistinct(id: string, otherId: string): Promise<void> {
    if (id === otherId) throw new ApiError('VALIDATION_ERROR', 'Elige dos proveedores distintos.', 400);
    if (!state.suppliers.some((s) => s.supplierId === id) || !state.suppliers.some((s) => s.supplierId === otherId)) throw notFound('ese proveedor');
    state.suppliers = state.suppliers.map((s) => {
      const otro = s.supplierId === id ? otherId : s.supplierId === otherId ? id : null;
      return otro ? { ...s, distinctFrom: [...new Set([...(s.distinctFrom ?? []), otro])] } : s;
    });
  },

  async mergeSuppliers(intoId: string, fromId: string) {
    if (intoId === fromId) throw new ApiError('VALIDATION_ERROR', 'No puedes unir un proveedor consigo mismo.', 400);
    const into = state.suppliers.find((s) => s.supplierId === intoId);
    const from = state.suppliers.find((s) => s.supplierId === fromId);
    if (!into || !from) throw notFound('ese proveedor');
    let ingredients = 0;
    state.ingredients = state.ingredients.map((i) => (i.supplierId === fromId ? (ingredients++, { ...i, supplierId: intoId }) : i));
    let expenses = 0;
    state.expenses = state.expenses.map((e) => (e.supplierId === fromId ? (expenses++, { ...e, supplierId: intoId }) : e));
    // Como la API: alias y «No es un ingrediente» del que desaparece pasan al que se queda.
    state.ingredients = state.ingredients.map((i) => {
      const aliases = aliasesDeProveedorUnido(i.aliases, fromId, intoId);
      return aliases === i.aliases ? i : { ...i, aliases };
    });
    const reglas = reglasDeProveedorUnido(noIngredientRules, fromId, intoId);
    if (reglas.remove.length) await this.updateNoIngredientLines(reglas);
    const supplier = proveedorUnido(into, from);
    state.suppliers = state.suppliers.filter((s) => s.supplierId !== fromId).map((s) => (s.supplierId === intoId ? supplier : s));
    proveedoresUnidos.set(fromId, intoId);
    return { supplier, ingredients, expenses };
  },

  /* --- Recetas --- */

  async listRecipes(): Promise<Recipe[]> {
    return [...state.recipes].sort((a, b) => a.name.localeCompare(b.name, 'es'));
  },

  async getRecipe(id: string): Promise<Recipe> {
    const recipe = state.recipes.find((r) => r.recipeId === id);
    if (!recipe) throw notFound('esa receta');
    return recipe;
  },

  async createRecipe(input: RecipeInput): Promise<Recipe> {
    // Como la API (recipeInputSchema): solo photos/…, data:image o https.
    if (input.photo && !esFotoGuardable(input.photo)) throw new ApiError('VALIDATION_ERROR', 'La foto no tiene un formato válido.', 400);
    const created: Recipe = {
      ...input,
      safetyMarginCustom: input.safetyMarginCustom ?? input.safetyMarginPct !== colchonDeCuenta(state.settings),
      tenantId: TENANT_ID,
      recipeId: newId('rec'),
      updatedAt: new Date().toISOString(),
    };
    state.recipes = [...state.recipes, created];
    return created;
  },

  async updateRecipe(id: string, input: RecipeInput): Promise<Recipe> {
    // Como la API (recipeInputSchema): solo photos/…, data:image o https.
    if (input.photo && !esFotoGuardable(input.photo)) throw new ApiError('VALIDATION_ERROR', 'La foto no tiene un formato válido.', 400);
    const current = state.recipes.find((r) => r.recipeId === id);
    if (!current) throw notFound('esa receta');
    const updated: Recipe = {
      ...current,
      ...input,
      safetyMarginCustom: input.safetyMarginCustom ?? input.safetyMarginPct !== colchonDeCuenta(state.settings),
      recipeId: id,
      tenantId: TENANT_ID,
      updatedAt: new Date().toISOString(),
    };
    state.recipes = state.recipes.map((r) => (r.recipeId === id ? updated : r));
    return updated;
  },

  async deleteRecipe(id: string): Promise<void> {
    // Misma red y mismo mensaje que la API (mejora 50): shared/recipeUsage.ts.
    const aviso = recipeUsageMessage(recipeUsage(id, state.recipes, state.menuItems));
    if (aviso) throw new ApiError('CONFLICT', aviso, 409);
    state.recipes = state.recipes.filter((r) => r.recipeId !== id);
    // Su enlace público de cocina muere con ella (como en la API).
    demoKitchenLinks.delete(id);
  },

  async getRecipeCost(id: string): Promise<RecipeCost> {
    if (!state.recipes.some((r) => r.recipeId === id)) throw notFound('esa receta');
    return computeRecipeCostPartial(id, context());
  },

  /*
   * Fase 7 · enlace público de cocina. Espejo de routes/kitchenLinks.ts: un
   * token por receta, crear dos veces devuelve el mismo, cambiar invalida el
   * viejo y la vista sale de buildKitchenShareView (la misma lista blanca que
   * la API). En la demo vive en memoria: recargar la página lo olvida.
   */
  async listKitchenLinks(): Promise<KitchenLink[]> {
    return [...demoKitchenLinks.values()].map(clone);
  },

  async createKitchenLink(recipeId: string): Promise<KitchenLink> {
    if (!state.recipes.some((r) => r.recipeId === recipeId)) throw notFound('esa receta');
    const existing = demoKitchenLinks.get(recipeId);
    if (existing) return clone(existing);
    const link: KitchenLink = { recipeId, token: demoKitchenToken(), createdAt: new Date().toISOString() };
    demoKitchenLinks.set(recipeId, link);
    return clone(link);
  },

  async regenerateKitchenLink(recipeId: string): Promise<KitchenLink> {
    if (!state.recipes.some((r) => r.recipeId === recipeId)) throw notFound('esa receta');
    demoKitchenLinks.delete(recipeId);
    return demoApi.createKitchenLink(recipeId);
  },

  async revokeKitchenLink(recipeId: string): Promise<void> {
    demoKitchenLinks.delete(recipeId);
  },

  async getPublicKitchenView(token: string): Promise<KitchenShareView> {
    const gone = new ApiError('NOT_FOUND', 'Este enlace ya no funciona.', 404);
    if (!KITCHEN_TOKEN_RE.test(token)) throw gone;
    const link = [...demoKitchenLinks.values()].find((l) => l.token === token);
    if (!link || state.tenant.subscriptionStatus === 'canceled') throw gone;
    const view = buildKitchenShareView(link.recipeId, state.recipes, state.ingredients, state.tenant.name, state.menuItems);
    if (!view) throw gone;
    // Las fotos de la demo son data-URL dentro de la receta: viajan tal cual, como en la API.
    return clone(view);
  },

  async getRecipeCosts(): Promise<RecipeCostsResponse> {
    const ctx = context();
    return {
      items: state.recipes.map((recipe) => {
        try {
          return { recipeId: recipe.recipeId, cost: computeRecipeCostPartial(recipe.recipeId, ctx) };
        } catch (error) {
          return {
            recipeId: recipe.recipeId,
            error: {
              message:
                error instanceof Error
                  ? error.message
                  : 'No hemos podido costear esta receta.',
              culprit:
                error instanceof CostingError || error instanceof UnitError
                  ? error.culprit
                  : undefined,
            },
          };
        }
      }),
    };
  },

  async proposeRecipeFromFile(_file: Blob): Promise<RecipeProposalResponse> {
    const proposal = DEMO_MX_RECIPE_PROPOSAL;
    return { draftId: (await this.createRecipeDraft(proposal)).id, proposal, plan: planRecipeProposal(proposal, state.ingredients), rows: proposalToImportRows(proposal, state.ingredients, state.recipes), catalog: state.ingredients, recipeCatalog: state.recipes };
  },

  async proposeRecipe(text: string, contexto?: ContextoAlta): Promise<RecipeProposalResponse> {
    const voiceApi = (import.meta.env.VITE_VOICE_API_URL ?? '').trim().replace(/\/+$/, '');
    if (voiceApi) {
      const response = await fetch(`${voiceApi}/v1/recipes/proposal`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ text, ...(contexto ? { contexto } : {}) }),
      });
      const payload = await response.json() as RecipeProposalResponse & {
        error?: { message?: string };
      };
      if (!response.ok || !payload.proposal) {
        throw new ApiError(
          'INTERNAL',
          payload.error?.message ?? 'No he podido interpretar la receta.',
          response.status,
        );
      }
      return payload;
    }
    /*
     * La demo simula el dictado: unas croquetas salen como el modelo las
     * devolvía (masa y porción mezcladas) y pasan por la MISMA red que la API
     * (`ordenarPropuestas`): preparación + plato. Lo demás, el pozole.
     */
    // El precio de las croquetas sale de lo que escribió («… a 9,90»), no del ejemplo.
    const crudas = /croqueta/i.test(text)
      ? structuredClone(CROQUETAS_FIXTURE.proposals).map(({ sellingPriceGross: _precio, ...p }) => p)
      : [structuredClone(DEMO_MX_RECIPE_PROPOSAL)];
    const proposals = ordenarPropuestas(crudas, { texto: text, contexto });
    const draftIds: string[] = [];
    for (const p of proposals) draftIds.push((await this.createRecipeDraft(p)).id);
    const proposal = proposals[0];
    return {
      draftId: draftIds[0],
      draftIds,
      proposal,
      proposals,
      plan: planRecipeProposal(proposal, state.ingredients),
      rows: proposalToImportRows(proposal, state.ingredients, state.recipes),
      recipeCatalog: state.recipes.map(({ recipeId, name }) => ({ recipeId, name })),
      catalog: state.ingredients.map(({ ingredientId, name, purchaseUnit, aliases }) => ({ ingredientId, name, purchaseUnit, ...(aliases?.length ? { aliases } : {}) })),
    };
  },

  async confirmRecipeProposal(input: ConfirmRecipeProposalInput): Promise<ConfirmRecipeProposalResponse> {
    const rows = proposalToImportRows({ ...input, lines: input.lines.map((line) => ({
      ...line, rawText: line.ingredientName, isSubrecipe: Boolean(line.recipeId), estimated: { qty: line.estimated },
    })) }, state.ingredients, state.recipes, Object.fromEntries(input.lines.map((line, index) => [index, line])));
    if (rows.issues.length) throw new ApiError('VALIDATION_ERROR', rows.issues.map((issue) => issue.message).join(' · '), 400);
    const beforeIngredients = new Set(state.ingredients.map((ing) => ing.ingredientId));
    const beforeRecipes = new Set(state.recipes.map((recipe) => recipe.recipeId));
    if (rows.ingredientStubs.length) {
      const added = await this.importIngredients({ items: rows.ingredientStubs.map((input) => ({ input })) });
      if (added.errores.length) throw new ApiError('VALIDATION_ERROR', added.errores.map((error) => error.message).join(' · '), 400);
    }
    const cuenta = colchonDeCuenta(state.settings);
    const colchon = { safetyMarginPct: input.safetyMarginPct ?? cuenta, safetyMarginCustom: input.safetyMarginPct != null && input.safetyMarginPct !== cuenta };
    const saved = await this.importRecipes({ items: rows.recipeRows.map((row) => ({ id: input.recipeId, input: { ...row, ...colchon } })) });
    if (saved.errores.length) throw new ApiError('VALIDATION_ERROR', saved.errores.map((error) => error.message).join(' · '), 400);
    const recipe = state.recipes.find((recipe) => input.recipeId ? recipe.recipeId === input.recipeId : !beforeRecipes.has(recipe.recipeId))!;
    return { recipe, newIngredients: state.ingredients.filter((ing) => !beforeIngredients.has(ing.ingredientId)) };
  },

  /* --- Carta y precios --- */

  async listMenuItems(): Promise<MenuItem[]> {
    return [...state.menuItems];
  },

  async createMenuItem(input: MenuItemInput): Promise<MenuItem> {
    const created: MenuItem = {
      ...input,
      tenantId: TENANT_ID,
      menuItemId: newId('menu'),
      updatedAt: new Date().toISOString(),
    };
    // El coste teorico se fija solo, con el coste del dia en que se creo el
    // plato. Nadie lo teclea a mano.
    if (created.theoreticalCost === undefined) {
      try {
        created.theoreticalCost = computeRecipeCost(created.recipeId, context()).costPerPortion;
        created.theoreticalCostAt = created.updatedAt;
        created.theoreticalCostIngredients = ingredientCostShares(created.recipeId, state.ingredients, state.recipes);
      } catch {
        // receta sin costear: la referencia llegara al primer "aceptar coste"
      }
    }
    state.menuItems = [...state.menuItems, created];
    return created;
  },

  async acceptMenuItemCost(id: string): Promise<MenuItem> {
    const current = state.menuItems.find((m) => m.menuItemId === id);
    if (!current) throw notFound('ese plato de la carta');
    const cost = computeRecipeCost(current.recipeId, context());
    const updated: MenuItem = {
      ...current,
      theoreticalCostIngredients: ingredientCostShares(current.recipeId, state.ingredients, state.recipes),
      theoreticalCost: cost.costPerPortion,
      theoreticalCostAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
    state.menuItems = state.menuItems.map((m) => (m.menuItemId === id ? updated : m));
    return updated;
  },

  async updateMenuItem(id: string, input: MenuItemInput): Promise<MenuItem> {
    const current = state.menuItems.find((m) => m.menuItemId === id);
    if (!current) throw notFound('ese plato de la carta');
    // Igual que la API: un precio nuevo guarda el costo de ese momento.
    const cambiaPrecio = input.sellingPriceGross !== current.sellingPriceGross
      || JSON.stringify(input.channelPrices ?? {}) !== JSON.stringify(current.channelPrices ?? {});
    let referencia = {};
    if (cambiaPrecio) {
      try {
        referencia = {
          theoreticalCostIngredients: ingredientCostShares(input.recipeId, state.ingredients, state.recipes),
          theoreticalCost: computeRecipeCost(input.recipeId, context()).costPerPortion,
          theoreticalCostAt: new Date().toISOString(),
        };
      } catch { /* sin costear: se queda la referencia */ }
    }
    const updated: MenuItem = {
      ...current,
      ...input,
      previousNames: [...new Set([...(current.previousNames ?? []), ...(current.name !== input.name ? [current.name] : [])])].slice(-50),
      ...referencia,
      menuItemId: id,
      tenantId: TENANT_ID,
      updatedAt: new Date().toISOString(),
    };
    state.menuItems = state.menuItems.map((m) => (m.menuItemId === id ? updated : m));
    return updated;
  },

  async updateMenuItemUnitsSold(id: string, unitsSold: number, locationId?: string): Promise<MenuItem> {
    const current = state.menuItems.find((m) => m.menuItemId === id);
    if (!current) throw notFound('ese plato de la carta');
    const updated = {
      ...(locationId
        ? withUnitsForLocation(current, locationId, unitsSold)
        : { ...current, unitsSold, unitsSoldByLocation: undefined }),
      updatedAt: new Date().toISOString(),
    };
    state.menuItems = state.menuItems.map((m) => (m.menuItemId === id ? updated : m));
    return updated;
  },

  async deleteMenuItem(id: string): Promise<void> {
    state.menuItems = state.menuItems.filter((m) => m.menuItemId !== id);
  },

  async getPricing(locationId?: string, salesRange?: Period): Promise<PricingResponse> {
    // Como la API: fechas válidas y un año como mucho.
    if (salesRange) {
      const { error } = salesRangeOf(salesRange.start, salesRange.end);
      if (error) throw new ApiError('VALIDATION_ERROR', error, 400);
    }
    const { rows, skipped } = pricingItems();
    // Fase 7, como la API: con rango, las unidades salen de las cargas con fecha.
    const enRango = salesRange ? unitsInRange(state.dishSales, salesRange, locationId).units : null;
    const unidades = (item: MenuItem): number =>
      enRango ? Math.round(enRango.get(item.menuItemId) ?? 0) : locationId ? unitsSoldFor(item, locationId) : item.unitsSold ?? 0;
    return {
      items: rows.map((r) => r.analysis),
      engineering: menuEngineering(
        rows.map(({ item, analysis }) => ({
          item: { ...item, unitsSold: unidades(item) },
          analysis,
          // El grupo de carta vive en la receta: la matriz clasifica por grupo.
          group: state.recipes.find((r) => r.recipeId === item.recipeId)?.group ?? null,
        })),
      ),
      skipped,
    };
  },

  async listDishSales(): Promise<DishSalesPeriod[]> {
    return clone(state.dishSales).sort((a, b) => b.end.localeCompare(a.end) || b.start.localeCompare(a.start));
  },

  /** Igual que `saveDishSales` de la API: guarda y, si es la última del local, la copia a la carta. */
  async saveDishSales(raw: DishSalesInput): Promise<DishSalesPeriod> {
    // Mismo schema y misma comprobación de local que `POST /v1/dish-sales`.
    const parsed = dishSalesInputSchema.safeParse(raw);
    if (!parsed.success) throw new ApiError('VALIDATION_ERROR', parsed.error.issues[0]?.message ?? 'Revisa la carga de ventas.', 400);
    const locationId = parsed.data.locationId ? requireDemoActiveLocation(parsed.data.locationId) : undefined;
    const input = { ...parsed.data, locationId };
    const period = buildDishSalesPeriod(TENANT_ID, input, nowIso());
    const previous = state.dishSales;
    state.dishSales = [...previous.filter((p) => p.salesId !== period.salesId), period];
    if (isLatestDishSales(period, previous)) {
      const units = new Map(period.lines.map((l) => [l.menuItemId, l.units]));
      state.menuItems = state.menuItems.map((item) => {
        const value = units.get(item.menuItemId) ?? 0;
        if (!item.active && value === 0) return item;
        // Sin local en un negocio con varios: al principal, sin borrar los demás.
        return withUnitsFromDishSales(item, input.locationId, value);
      });
    }
    return clone(period);
  },

  async getPlatformComparison(id: string): Promise<PricingAnalysis[]> {
    const item = state.menuItems.find((m) => m.menuItemId === id);
    if (!item) throw notFound('ese plato de la carta');
    return comparePlatforms(item, costOf(item.recipeId), state.settings);
  },

  async getCostDeviations(): Promise<CostDeviation[]> {
    const rows = pricingItems().rows.map(({ item, cost }) => ({ item, cost }));
    return findCostDeviations(rows, state.settings);
  },

  /* --- Ingresos diarios --- */

  async listRevenues(period: Period, locationId?: string): Promise<DailyRevenue[]> {
    const lista = ambitoDemo(locationId);
    return state.revenues
      .filter((d) => inPeriod(d.date, period) && enAmbito(d.locationId, lista))
      .sort((a, b) => a.date.localeCompare(b.date));
  },

  async saveRevenue(input: DailyRevenueInput): Promise<DailyRevenue> {
    // Como la API: un día por fecha Y local (con varios locales, cada uno el suyo).
    const locationId = requireDemoActiveLocation(input.locationId);
    const { importSource, ...values } = input as DailyRevenueInput & { importSource?: 'excel' };
    const saved: DailyRevenue = {
      ...values,
      locationId,
      source: importSource ?? 'manual',
      tenantId: TENANT_ID,
      updatedAt: new Date().toISOString(),
    };
    const mismo = (d: DailyRevenue) => d.date === input.date && sameLocation(d.locationId, locationId);
    const exists = state.revenues.some(mismo);
    state.revenues = exists
      ? state.revenues.map((d) => (mismo(d) ? saved : d))
      : [...state.revenues, saved];
    return saved;
  },

  async deleteRevenue(date: string, locationId?: string): Promise<void> {
    state.revenues = state.revenues.filter((d) => !(d.date === date && sameLocation(d.locationId, locationId)));
  },

  /** Espejo de GET/POST /v1/revenues/iva-antes (ver shared/ventasIvaAntes.ts). */
  async getIvaAntes(): Promise<EstadoIvaAntes> {
    if (!['owner', 'admin'].includes(state.user.role)) return { preguntar: false, dias: 0 };
    return estadoIvaAntes(state.tenant.ventasIvaAntes, state.revenues, state.settings, todosLosLocales());
  },

  async answerIvaAntes(respuesta: RespuestaIvaAntes): Promise<VentasIvaAntes & { corregidas: number }> {
    if (!['owner', 'admin'].includes(state.user.role)) throw new ApiError('FORBIDDEN', 'No tienes permisos suficientes para esta operación. Pide acceso al propietario.', 403);
    if (state.tenant.ventasIvaAntes) return { ...state.tenant.ventasIvaAntes, corregidas: 0 };
    let corregidas = 0;
    if (respuesta === 'con') {
      const locales = todosLosLocales();
      const porCorregir = new Set(ventasPorCorregirIva(state.revenues, state.settings, locales));
      const at = new Date();
      state.revenues = state.revenues.map((r) => {
        const pct = porCorregir.has(r) ? ivaParaCorregir(r, state.settings, locales) : null;
        if (pct == null) return r;
        corregidas += 1;
        return corregirIvaDia(r, pct, at);
      });
    }
    const guardada: VentasIvaAntes = { respuesta, at: new Date().toISOString(), ...(respuesta === 'con' ? { corregidas } : {}) };
    state.tenant = { ...state.tenant, ventasIvaAntes: guardada };
    return { ...guardada, corregidas };
  },

  /* --- Gastos --- */

  async listExpenses(period: Period, locationId?: string): Promise<ExpenseEntry[]> {
    const lista = ambitoDemo(locationId);
    const items = state.expenses
      .filter((e) => inPeriod(e.date, period) && (enAmbito(e.locationId, lista) || e.locationId === SHARED_LOCATION_ID))
      .sort((a, b) => b.date.localeCompare(a.date));
    // Como la API: con uno o algunos locales, los comunes traen la parte que les toca.
    return conImporteDelLocal({
      expenses: items,
      revenues: state.revenues,
      locationIds: lista,
      activeLocationIds: todosLosLocales().filter((l) => l.active).map((l) => l.locationId),
      allocation: state.settings.sharedCostAllocation,
    });
  },

  async getExpense(id: string): Promise<ExpenseEntry> {
    const found = state.expenses.find((e) => e.entryId === id);
    if (!found) throw new Error('Ese gasto ya no existe.');
    return found;
  },

  async listReconciliationCandidates(invoiceId: string): Promise<ExpenseEntry[]> {
    const invoice = state.expenses.find((expense) => expense.entryId === invoiceId);
    if (!invoice) throw notFound('la factura');
    // Igual que la API: sin proveedor no hay emparejamiento posible.
    return state.expenses.filter((expense) =>
      expense.documentType === 'albaran' &&
      !expense.reconciledInvoiceId &&
      (!expense.supplierId || (invoice.supplierId ? expense.supplierId === invoice.supplierId : false))
    );
  },

  async listImportMappings(kind) {
    return demoImportMappings[kind] ?? [];
  },
  async saveImportMapping(kind, input) {
    demoImportMappings[kind] = rememberMapping(demoImportMappings[kind] ?? [], input, new Date().toISOString());
    return demoImportMappings[kind];
  },
  async listCuadreFuentes(kind) {
    return demoCuadre.filter((f) => f.kind === kind);
  },
  async saveCuadreFuente(kind, month, locationId, input) {
    const scope = locationId ?? CUADRE_TODOS;
    const fuente: CuadreFuente = {
      kind, month, scope,
      sourceTotal: input.sourceTotal,
      includesVat: input.includesVat,
      ...(input.sourceName ? { sourceName: input.sourceName } : {}),
      ...(input.accepted ? { accepted: true } : {}),
      updatedAt: new Date().toISOString(),
    };
    demoCuadre = [...demoCuadre.filter((f) => !(f.kind === kind && f.month === month && f.scope === scope)), fuente];
    return fuente;
  },
  async deleteCuadreFuente(kind, month, locationId) {
    const scope = locationId ?? CUADRE_TODOS;
    demoCuadre = demoCuadre.filter((f) => !(f.kind === kind && f.month === month && f.scope === scope));
  },
  async importExpenses(items: ExpenseInput[], permitirRepetidos?: number[]): Promise<{ created: number; skipped: number }> {
    // Igual que la API: un gasto ya importado no se crea otra vez, salvo los
    // que el usuario dijo «Es otra» o van a «Por confirmar».
    const permitidos = new Set(permitirRepetidos ?? []);
    const conIndice = items.map((input, i) => ({ input, i }));
    const { nuevos, repetidos } = separarRepetidos(conIndice.filter((x) => !permitidos.has(x.i)), state.expenses);
    const todos = [...conIndice.filter((x) => permitidos.has(x.i)), ...nuevos];
    for (const { input } of todos) await this.createExpense(input);
    return { created: todos.length, skipped: repetidos.length };
  },

  /** Como GET /v1/expenses/por-confirmar: del ámbito pedido, más los «de todos». */
  async listPorConfirmar(locationId?: string): Promise<ExpenseEntry[]> {
    const lista = ambitoDemo(locationId);
    return state.expenses
      .filter((e) => e.porConfirmar && (enAmbito(e.locationId, lista) || e.locationId === SHARED_LOCATION_ID))
      .sort((a, b) => b.date.localeCompare(a.date));
  },

  async createExpense(input: ExpenseInput): Promise<ExpenseEntry> {
    // Igual que la API: una nota de venta nace pendiente de factura; el pago
    // lo dice quien la registra.
    const created: ExpenseEntry = {
      ...input,
      ...camposDeReparto(input),
      ...(input.documentType === 'albaran' ? { invoiceStatus: 'pendiente' as const } : {}),
      tenantId: TENANT_ID,
      entryId: newId('exp'),
    };
    state.expenses = [...state.expenses, created];
    return created;
  },

  async updateExpense(id: string, input: ExpenseInput): Promise<ExpenseEntry> {
    const current = state.expenses.find((e) => e.entryId === id);
    if (!current) throw notFound('ese gasto');
    const reconciled = Boolean(current.reconciledInvoiceId || current.deliveryNoteIds?.length);
    const accountingChanged =
      current.date !== input.date ||
      current.netAmount !== input.netAmount ||
      current.supplierId !== input.supplierId ||
      (current.documentType ?? 'factura') !== (input.documentType ?? 'factura');
    if (reconciled && accountingChanged) {
      throw new Error('No se pueden cambiar los datos contables de un documento conciliado.');
    }
    // Igual que la API: el reparto entre meses ausente se conserva, null lo quita.
    const updated: ExpenseEntry = { ...current, ...input, ...camposDeReparto(input, current), paymentMethod: input.paymentMethod === undefined ? current.paymentMethod : input.paymentMethod, entryId: id, tenantId: TENANT_ID };
    // Igual que la API (el PUT reemplaza el gasto): sin `porConfirmar`, queda confirmado.
    if (input.porConfirmar === undefined) delete updated.porConfirmar;
    // Como la API (bloque S): corregir una «Guardada sin revisar» la da por revisada y cuenta.
    if (current.guardadaSinRevisar) {
      const cambio = accountingChanged || current.category !== input.category || (current.taxAmount ?? null) !== (input.taxAmount ?? null);
      if (cambio) { delete updated.guardadaSinRevisar; demoScanStats.corregidas += 1; }
    }
    // Igual que la API: el estado de un albaran lo dicta su conciliacion.
    if ((updated.documentType ?? 'factura') === 'albaran') {
      updated.invoiceStatus = updated.reconciledInvoiceId ? 'facturado' : 'pendiente';
      if (updated.reconciledInvoiceId) updated.paid = true;
    }
    state.expenses = state.expenses.map((e) => (e.entryId === id ? updated : e));
    // Igual que la API: en una factura o nota juntada, lo que cuenta cada
    // parte se recalcula con los importes nuevos y se regraba en todas.
    if (reconciled) {
      const factura = state.expenses.find((e) => e.entryId === (updated.deliveryNoteIds?.length ? updated.entryId : updated.reconciledInvoiceId));
      const notas = state.expenses.filter((e) => factura && e.reconciledInvoiceId === factura.entryId && factura.deliveryNoteIds?.includes(e.entryId));
      if (factura && notas.length === (factura.deliveryNoteIds?.length ?? 0)) {
        const reparto = repartoAlJuntar(factura, notas);
        state.expenses = state.expenses.map((e) => (e.entryId === factura.entryId
          ? { ...e, netoQueCuenta: reparto.factura }
          : reparto.notas.has(e.entryId) ? { ...e, netoQueCuenta: reparto.notas.get(e.entryId) } : e));
        return state.expenses.find((e) => e.entryId === id) ?? updated;
      }
    }
    return updated;
  },

  async deleteExpense(id: string): Promise<void> {
    const current = state.expenses.find((e) => e.entryId === id);
    if (current && (current.reconciledInvoiceId || current.deliveryNoteIds?.length)) {
      throw new Error('No se puede borrar un documento conciliado: forma parte del histórico de la compra.');
    }
    state.expenses = state.expenses.filter((e) => e.entryId !== id);
  },

  async reconcileExpense(invoiceId: string, deliveryNoteIds: string[], marcarFacturaPagada?: boolean): Promise<ReconciliationResult> {
    if (new Set(deliveryNoteIds).size !== deliveryNoteIds.length) {
      throw new Error('No se puede repetir un mismo albarán.');
    }
    const invoice = state.expenses.find((e) => e.entryId === invoiceId);
    const deliveryNotes = state.expenses.filter((e) => deliveryNoteIds.includes(e.entryId));
    if (!invoice || deliveryNotes.length !== deliveryNoteIds.length) throw notFound('alguno de los documentos');
    // Igual que la API (bloque G): si las notas se pasan de la factura, no se juntan.
    const cuadre = cuadreAlJuntar(deliveryNotes.reduce((acc, n) => acc + totalDeGasto(n), 0), totalDeGasto(invoice), invoice.netAmount);
    if (cuadre.estado === 'te_pasas') {
      throw new Error(`Te pasas ${formatMoneyIn(cuadre.diferencia, state.tenant.currency)}: alguna nota marcada no es de esta factura.`);
    }
    const reparto = repartoAlJuntar(invoice, deliveryNotes);
    const totalAlbaranes = Math.round(deliveryNotes.reduce((sum, e) => sum + e.netAmount, 0) * 100) / 100;
    const difference = Math.round((invoice.netAmount - totalAlbaranes) * 100) / 100;
    const reconciliationStatus = Math.abs(difference) < 0.01 ? 'conciliado' as const : 'con_diferencias' as const;
    const reconciledAt = new Date().toISOString();
    const pagar = Boolean(marcarFacturaPagada) && !invoice.paid;
    // Igual que la API: el proveedor de la compra es el de la factura o, si no
    // lo tiene, el unico de sus notas.
    const proveedorDeLaCompra = invoice.supplierId ?? deliveryNotes.map((n) => n.supplierId).find(Boolean);
    const nextInvoice = {
      ...invoice,
      supplierId: proveedorDeLaCompra,
      deliveryNoteIds,
      reconciliationStatus,
      reconciliationDifference: difference,
      reconciledAt,
      netoQueCuenta: reparto.factura,
      ...(pagar
        ? {
            paid: true,
            paymentDate: ultimaFechaDePago(deliveryNotes, reconciledAt.slice(0, 10)),
          }
        : {}),
    };
    state.expenses = state.expenses.map((e) => {
      if (e.entryId === invoiceId) return nextInvoice;
      // Igual que la API: el albaran conciliado sale de pendiente.
      if (deliveryNoteIds.includes(e.entryId)) return { ...e, supplierId: e.supplierId ?? proveedorDeLaCompra, reconciledInvoiceId: invoiceId, reconciliationStatus, reconciliationDifference: difference, reconciledAt, invoiceStatus: 'facturado' as const, paid: true, netoQueCuenta: reparto.notas.get(e.entryId) ?? e.netAmount };
      return e;
    });
    return { invoice: nextInvoice, deliveryNotes: state.expenses.filter((e) => deliveryNoteIds.includes(e.entryId)), totalAlbaranes, difference };
  },

  async unreconcileExpense(invoiceId: string): Promise<{ invoiceId: string; deliveryNotes: number }> {
    const invoice = state.expenses.find((e) => e.entryId === invoiceId);
    if (!invoice?.deliveryNoteIds?.length) throw new Error('Esta factura no está conciliada.');
    const ids = new Set(invoice.deliveryNoteIds);
    state.expenses = state.expenses.map((e) => {
      if (e.entryId === invoiceId) {
        const { deliveryNoteIds: _ids, reconciliationStatus: _s, reconciliationDifference: _d, reconciledAt: _a, netoQueCuenta: _n, ...resto } = e;
        return resto;
      }
      if (ids.has(e.entryId)) {
        const { reconciledInvoiceId: _i, reconciliationStatus: _s, reconciliationDifference: _d, reconciledAt: _a, netoQueCuenta: _n, ...resto } = e;
        return { ...resto, invoiceStatus: 'pendiente' as const };
      }
      return e;
    });
    return { invoiceId, deliveryNotes: ids.size };
  },

  async getPayables(today: string, locationId?: string): Promise<PayablesResponse> {
    return payablesResponse(today || todayIso(), locationId);
  },

  /* --- Inversiones --- */

  async listInvestments(locationId?: string): Promise<Investment[]> {
    const lista = ambitoDemo(locationId);
    // Como la API: las «de todos» se ven desde cualquier local.
    return state.investments.filter((i) => i.locationId === SHARED_LOCATION_ID || enAmbito(i.locationId, lista)).sort((a, b) => a.date.localeCompare(b.date));
  },

  async createInvestment(input: InvestmentInput): Promise<Investment> {
    const created: Investment = { ...input, tenantId: TENANT_ID, investmentId: newId('inv') };
    state.investments = [...state.investments, created];
    return created;
  },

  async updateInvestment(id: string, input: InvestmentInput): Promise<Investment> {
    const current = state.investments.find((i) => i.investmentId === id);
    if (!current) throw notFound('esa inversión');
    const updated: Investment = {
      ...current,
      ...input,
      investmentId: id,
      tenantId: TENANT_ID,
    };
    state.investments = state.investments.map((i) => (i.investmentId === id ? updated : i));
    return updated;
  },

  async deleteInvestment(id: string): Promise<void> {
    state.investments = state.investments.filter((i) => i.investmentId !== id);
  },

  async getAmortizationSchedule(month: string, locationId?: string): Promise<AmortizationRow[]> {
    const lista = ambitoDemo(locationId);
    return amortizationSchedule(state.investments.filter((i) => enAmbito(i.locationId, lista)), month || currentMonth());
  },

  /* --- Bloque I: préstamos y gastos que parecen inversiones --- */

  async listLoans(locationId?: string) {
    const desde = sumarMeses(currentMonth(), -11);
    const lista = ambitoDemo(locationId);
    return {
      items: clone(state.loans.filter((l) => l.locationId === SHARED_LOCATION_ID || enAmbito(l.locationId, lista))),
      interesesAMano: interesesAMano(state.expenses.filter((e) => e.locationId === SHARED_LOCATION_ID || enAmbito(e.locationId, lista)), desde),
    };
  },

  async createLoan(input) {
    const parsed = loanInputSchema.safeParse(input);
    if (!parsed.success) throw new ApiError('VALIDATION_ERROR', parsed.error.issues[0]?.message ?? 'Revisa los datos del préstamo.', 400);
    const created: Loan = { ...parsed.data, tenantId: TENANT_ID, loanId: newId('loan') };
    state.loans = [...state.loans, created];
    return clone(created);
  },

  async updateLoan(id, input) {
    if (!state.loans.some((l) => l.loanId === id)) throw notFound('ese préstamo');
    const parsed = loanInputSchema.safeParse(input);
    if (!parsed.success) throw new ApiError('VALIDATION_ERROR', parsed.error.issues[0]?.message ?? 'Revisa los datos del préstamo.', 400);
    const updated: Loan = { ...parsed.data, tenantId: TENANT_ID, loanId: id };
    state.loans = state.loans.map((l) => (l.loanId === id ? updated : l));
    return clone(updated);
  },

  async deleteLoan(id) {
    state.loans = state.loans.filter((l) => l.loanId !== id);
  },

  async listLooksLikeInvestments(locationId?: string) {
    const lista = ambitoDemo(locationId);
    const hasta = currentMonth();
    const desde = sumarMeses(hasta, -11);
    const gastos = state.expenses.filter(
      (e) =>
        e.date.slice(0, 7) >= desde &&
        e.date.slice(0, 7) <= hasta &&
        (e.documentType ?? 'factura') === 'factura' &&
        (enAmbito(e.locationId, lista) || e.locationId === SHARED_LOCATION_ID),
    );
    return clone(gastosQueParecenInversiones(gastos, state.investments));
  },

  async investmentFromExpense(entryId) {
    const expense = state.expenses.find((e) => e.entryId === entryId);
    if (!expense) throw notFound('ese gasto');
    if (expense.reconciledInvoiceId || (expense.deliveryNoteIds?.length ?? 0) > 0) {
      throw new ApiError('VALIDATION_ERROR', 'No se puede borrar un documento conciliado: forma parte del histórico de la compra.', 400);
    }
    const input = investmentSchemaDemo.parse(inversionDesdeGasto(expense));
    const created: Investment = { ...input, tenantId: TENANT_ID, investmentId: newId('inv') };
    state.investments = [...state.investments, created];
    state.expenses = state.expenses.filter((e) => e.entryId !== entryId);
    return clone(created);
  },

  /* --- Movimientos de caja --- */

  async listCashMovements(period: Period, locationId?: string): Promise<CashMovement[]> {
    const lista = ambitoDemo(locationId);
    return state.cashMovements
      .filter((m) => inPeriod(m.date, period) && enAmbito(m.locationId, lista))
      .sort((a, b) => b.date.localeCompare(a.date));
  },

  async createCashMovement(input: CashMovementInput): Promise<CashMovement> {
    const created: CashMovement = { ...input, tenantId: TENANT_ID, movementId: newId('cash') };
    state.cashMovements = [...state.cashMovements, created];
    return created;
  },

  async deleteCashMovement(id: string): Promise<void> {
    state.cashMovements = state.cashMovements.filter((m) => m.movementId !== id);
  },

  /* --- Objetivos --- */

  async getTarget(month: string, locationId?: string): Promise<Target | null> {
    return objetivoDemo(month, locationId);
  },

  /** Compatibilidad (asistente del alta): escribe en los objetivos para siempre. */
  async saveTarget(month: string, input: TargetInput): Promise<Target> {
    const actual = state.targets.find((t) => isStandingTarget(t)) ?? resolverObjetivo(state.targets, 'principal', month, ['principal']).target;
    const next: Target = {
      tenantId: TENANT_ID,
      month: STANDING_TARGET_MONTH,
      salesMode: actual?.salesMode ?? 'igual',
      ...(actual?.monthlyRevenue ? { monthlyRevenue: { ...actual.monthlyRevenue } } : {}),
      ...(actual?.netRevenue != null ? { netRevenue: actual.netRevenue } : {}),
      ...(actual?.averageTicket != null ? { averageTicket: actual.averageTicket } : {}),
      ...(actual?.foodCostPct != null ? { foodCostPct: actual.foodCostPct } : {}),
      ...(actual?.laborCostPct != null ? { laborCostPct: actual.laborCostPct } : {}),
      ...(actual?.primeCostPct != null ? { primeCostPct: actual.primeCostPct } : {}),
      ...(actual?.ebitdaPct != null ? { ebitdaPct: actual.ebitdaPct } : {}),
    };
    if (input.netRevenue != null) {
      if (next.salesMode === 'por_mes') next.monthlyRevenue = { ...(next.monthlyRevenue ?? {}), [month.slice(5, 7)]: input.netRevenue };
      else next.netRevenue = input.netRevenue;
    }
    for (const k of ['averageTicket', 'foodCostPct', 'laborCostPct', 'primeCostPct', 'ebitdaPct'] as const) {
      if (input[k] != null) next[k] = input[k];
    }
    state.targets = [...state.targets.filter((t) => !isStandingTarget(t)), next];
    return objetivoDemo(month);
  },

  /** Como GET /v1/targets/standing: un local, `grupo` o, sin pedir nada, el que toque. */
  async getStandingTarget(locationId?: string) {
    const ids = todosLosLocales().filter((l) => l.active).map((l) => l.locationId);
    const same = mismosParaTodos(state.targets, ids);
    const pedido = locationId ? (locationId === SHARED_LOCATION_ID ? SHARED_LOCATION_ID : effectiveLocationId(locationId)) : undefined;
    const scope = pedido ?? (ids.length > 1 && same ? SHARED_LOCATION_ID : ids[0]);
    let target: Target | null;
    let fuente: import('@alexiarest/shared').FuenteObjetivo;
    if (scope === SHARED_LOCATION_ID) {
      const grupo = state.targets.find((t) => isStandingTarget(t) && t.locationId === SHARED_LOCATION_ID);
      target = grupo ?? null;
      fuente = grupo ? 'todos' : 'recomendado';
    } else {
      // Viendo un local: lo suyo, sin caer en la fila grupo si está marcado «los mismos para todos».
      const resuelto = resolverObjetivo(state.targets.filter((t) => t.locationId !== SHARED_LOCATION_ID || !same), scope, undefined, ids);
      target = resuelto.target ?? null;
      fuente = resuelto.fuente;
    }
    const mes = currentMonth();
    const desde = sumarMeses(mes, -13);
    const ventas = state.revenues.filter(
      (d) => d.date.slice(0, 7) >= desde && (scope === SHARED_LOCATION_ID || effectiveLocationId(d.locationId) === scope),
    );
    return {
      target: target ? clone(target) : null,
      fuente,
      sameForAllLocations: same,
      locationIds: ids,
      locationId: scope,
      ...contextoObjetivos(ventas, mes),
    };
  },

  /** Como PUT /v1/targets/standing: reemplaza la fila del local (o `grupo`). */
  async saveStandingTarget(input) {
    const parsed = standingTargetInputSchema.parse(input);
    const locationId = requireDemoActiveLocation(parsed.locationId === SHARED_LOCATION_ID ? SHARED_LOCATION_ID : parsed.locationId);
    const target: Target = { ...parsed, tenantId: TENANT_ID, month: STANDING_TARGET_MONTH, locationId };
    if (locationId !== SHARED_LOCATION_ID) delete target.sameForAllLocations;
    for (const k of Object.keys(target) as Array<keyof Target>) if (target[k] === undefined) delete target[k];
    const mismaFila = (t: Target) =>
      isStandingTarget(t) && (t.locationId === SHARED_LOCATION_ID ? SHARED_LOCATION_ID : effectiveLocationId(t.locationId)) === locationId;
    state.targets = [...state.targets.filter((t) => !mismaFila(t)), target];
    return clone(target);
  },

  /* --- Inventario --- */

  async listInventoryCounts(): Promise<InventoryCount[]> {
    return [...state.inventoryCounts].sort((a, b) => a.month.localeCompare(b.month));
  },

  async getInventoryCount(month: string, locationId?: string, kind?: InventoryCountKind, date?: string): Promise<InventoryCount> {
    return (
      state.inventoryCounts.find((c) => sameInventoryCount(c, { month, locationId, kind, date })) ?? {
        tenantId: TENANT_ID,
        month,
        ...(locationId ? { locationId } : {}),
        ...(kind === 'intermedio' ? { kind, date } : {}),
        lines: [],
        totalValue: 0,
        updatedAt: nowIso(),
      }
    );
  },

  /** Como `PUT /v1/inventory/:month` (fase 7): tipo, fecha, estado y 0 = contado. */
  async saveInventoryCount(month: string, input: InventoryCountInput): Promise<InventoryCount> {
    const kind = input.kind ?? (input.date ? 'cierre' : undefined);
    if (kind === 'intermedio' && !input.date) {
      throw new ApiError('VALIDATION_ERROR', 'Un recuento intermedio necesita su fecha.', 400);
    }
    // Cierre atrasado (14 oct 2026), como la API: sigue siéndolo al corregirlo.
    const previo = kind === 'cierre' ? state.inventoryCounts.find((c) => sameInventoryCount(c, { month, locationId: input.locationId, kind: 'cierre' })) : undefined;
    const atrasado = kind === 'cierre' && (input.atrasado === true || Boolean(previo?.atrasado));
    if (atrasado && !input.date) throw new ApiError('VALIDATION_ERROR', 'Un cierre atrasado necesita el día en que cuentas.', 400);
    if (kind && input.date) {
      const problema = checkCountDate({ kind, month, date: input.date, today: hoyDelNegocio(), atrasado });
      if (problema) throw new ApiError('VALIDATION_ERROR', problema, 400);
    }
    if (input.locationId && effectiveLocationId(input.locationId) !== 'principal') requireDemoActiveLocation(input.locationId);
    const { lines, totalValue: valorContado } = valueInventoryLines(input.lines ?? [], state.ingredients);
    const compradoDesde = atrasado ? comprasDeMateriaPrima(financeInput().expenses, periodoCierreAtrasado(month, input.date!)) : 0;
    const totalValue = atrasado ? estimarCierreAtrasado(valorContado, compradoDesde) : valorContado;
    const key = { month, locationId: input.locationId, kind, date: input.date };
    const existing = state.inventoryCounts.find((c) => sameInventoryCount(c, key)) ?? null;
    // Como en la API real: el centro principal se guarda sin locationId.
    const saved = mergeInventoryCount(
      existing,
      {
        month,
        locationId: input.locationId,
        ...(kind ? { kind } : {}),
        ...(input.date ? { date: input.date } : {}),
        ...(input.status ? { status: input.status } : {}),
        lines,
        totalValue,
        ...(atrasado ? { atrasado: { contadoEl: input.date!, valorContado, compradoDesde } } : {}),
      },
      TENANT_ID,
      nowIso(),
    );
    const savedKey = { month, locationId: saved.locationId, kind: countKind(saved), date: saved.date };
    state.inventoryCounts = existing
      ? state.inventoryCounts.map((c) => (sameInventoryCount(c, savedKey) ? saved : c))
      : [...state.inventoryCounts, saved];
    return saved;
  },

  async deleteInventoryCount(month: string, locationId?: string, kind?: InventoryCountKind, date?: string): Promise<void> {
    state.inventoryCounts = state.inventoryCounts.filter(
      (c) => !sameInventoryCount(c, { month, locationId, kind, date }),
    );
  },

  /** Como `loadInventoryResult` de la API, con los datos de la demo (un solo local). */
  async getInventoryResult(
    month: string,
    target: { locationId: string | null; kind?: InventoryCountKind; date?: string },
  ): Promise<InventoryResult> {
    const { rows, skipped } = pricingItems();
    const input = financeInput();
    const notUsed = state.inventoryNotUsed.principal ?? [];
    return inventoryResult({
      target: { month, kind: target.kind, date: target.date, locationId: target.locationId },
      counts: state.inventoryCounts,
      expenses: input.expenses,
      revenues: input.revenues,
      dishSales: state.dishSales,
      dishes: rows.map(({ analysis }) => ({
        menuItemId: analysis.menuItemId,
        name: analysis.name,
        costPerPortion: analysis.costPerPortion,
        sellingPriceNet: analysis.sellingPriceNet,
      })),
      uncosted: skipped.map((s) => s.name),
      toCountByLocation: {
        principal: state.ingredients.filter((i) => i.active && i.purchaseUnit && !notUsed.includes(i.ingredientId)).length,
      },
      activeLocationIds: ['principal'],
    });
  },

  /** Con un solo local salen todos los que se pueden contar, menos los «No se usa aquí». */
  async getInventoryIngredients() {
    const notUsed = state.inventoryNotUsed.principal ?? [];
    return {
      principal: {
        ingredientIds: state.ingredients
          .filter((i) => i.active && i.purchaseUnit && !notUsed.includes(i.ingredientId))
          .map((i) => i.ingredientId),
        notUsed: [...notUsed],
        deduced: false,
      },
    };
  },

  async setInventoryIngredientUsed(ingredientId: string, locationId: string | undefined, used: boolean): Promise<void> {
    const loc = requireDemoActiveLocation(locationId?.trim() || undefined);
    // Como la API: solo se aparta un ingrediente que existe, con tope por local.
    if (!used && !state.ingredients.some((i) => i.ingredientId === ingredientId)) throw notFound('ese ingrediente');
    const current = state.inventoryNotUsed[loc] ?? [];
    const next = used ? current.filter((id) => id !== ingredientId) : [...new Set([...current, ingredientId])];
    if (next.length > 2_000) throw new ApiError('VALIDATION_ERROR', 'No se pueden apartar más de 2000 ingredientes en un local.', 400);
    state.inventoryNotUsed = { ...state.inventoryNotUsed, [loc]: next };
  },

  /* --- Analitica --- */

  async getPnl(period: Period, locationId?: string) {
    return computeProfitAndLoss(financeInput(locationId), period);
  },

  async getMonthlyPnl(period: Period, locationId?: string) {
    return monthlyProfitAndLoss(financeInput(locationId), period);
  },

  async getCashFlow(period: Period, opening = 0, locationId?: string): Promise<CashFlowResponse> {
    const months = computeCashFlow(financeInput(locationId), period, state.settings, opening);
    return {
      months,
      alerts: cashAlerts(months, state.tenant.currency),
      projection: projectCashFlow(months, 3),
    };
  },

  async getKpis(period: Period, locationId?: string): Promise<KpisResponse> {
    const input = financeInput(locationId);
    const kpis = computeKpis(input, period, state.settings);
    return { kpis, benchmarks: benchmarkKpis(kpis), overview: businessOverview(input, period) };
  },

  async getWeekday(period: Period, locationId?: string) {
    const input = financeInput(locationId);
    return ((input.locations ?? []).some((l) => l.active && l.operatingWeekdays?.length) ? businessOverview(input, period).weekday : weekdayPerformance(input.revenues, period));
  },

  async getTargetComparison(month: string, locationId?: string) {
    return compareTargets(financeInput(locationId), objetivoDemo(month, locationId), month);
  },

  async allocateTax(input: TaxAllocationRequest) {
    return allocateTaxPayment(financeInput(), input.payment, input.months, input.base);
  },

  async getDashboard(period: Period, locationId?: string): Promise<DashboardResponse> {
    const input = financeInput(locationId);
    const kpis = computeKpis(input, period, state.settings);
    const cashflow = computeCashFlow(input, period, state.settings, 0);
    // Un solo costeo para los dos usos: platos mas vendidos y avisos de carta.
    const carta = pricingItems();
    return {
      kpis,
      benchmarks: benchmarkKpis(kpis),
      target: objetivoDemo(period.end.slice(0, 7), locationId),
      // Bloque I: sin objetivo de ventas, la propuesta para «Para hoy».
      ...(objetivoDemo(period.end.slice(0, 7), locationId).netRevenue == null
        ? { salesTargetProposal: contextoObjetivos(state.revenues, currentMonth()).propuesta }
        : {}),
      pnl: computeProfitAndLoss(input, period),
      monthly: monthlyProfitAndLoss(input, period),
      cashflow,
      alerts: cashAlerts(cashflow, state.tenant.currency),
      payables: payablesResponse(todayIso(), locationId),
      weekday: ((input.locations ?? []).some((l) => l.active && l.operatingWeekdays?.length) ? businessOverview(input, period).weekday : weekdayPerformance(input.revenues, period)),
      topDishes: menuEngineering(
        carta.rows.map(({ item, analysis }) => ({ item, analysis })),
      ).slice(0, 5),
      carta: {
        items: carta.rows.map(({ analysis }) => ({
          menuItemId: analysis.menuItemId,
          name: analysis.name,
          platformName: analysis.platformName,
          alerts: analysis.alerts,
          costDeviationPct: analysis.costDeviationPct,
          grossMarginPct: analysis.grossMarginPct,
        })),
        skipped: carta.skipped,
      },
    };
  },

  /* --- Asistente --- */

  async getAssistantSuggestions(period: Period): Promise<AssistantSuggestion[]> {
    return demoSuggestions(assistantData(), period, todayIso());
  },

  /**
   * La propuesta de mapeo, en la demo.
   *
   * No hay modelo detras, asi que se usa el mismo adivinador por nombres de
   * columna que ya lleva el importador, y se dice. Sirve para recorrer el
   * flujo entero —propuesta, motivos, revision— que es de lo que va la demo;
   * con Bedrock delante, la propuesta la hace el modelo y acierta con
   * cabeceras que no se parecen a las nuestras, que es el caso dificil.
   */
  async proponerMapeoVentas(input: {
    columnas: string[];
    muestra: string[][];
    destinos: Array<{ key: string; label: string }>;
  }): Promise<MapeoVentasPropuesta> {
    const porUnidades = input.destinos.some((d) => d.key === 'dish');
    const adivinado = porUnidades
      ? guessUnitsColumns(input.columnas)
      : guessRevenueColumns(input.columnas, state.settings.platforms ?? []);
    const validos = new Set(input.destinos.map((d) => d.key));

    return {
      columnas: input.columnas.map((cabecera, indice) => {
        const key = adivinado[indice] ? targetKey(adivinado[indice]) : 'ignore';
        const reconocida = key !== 'ignore' && validos.has(key);
        return {
          indice,
          destino: reconocida ? key : 'ignore',
          confianza: reconocida ? ('alta' as const) : ('baja' as const),
          motivo: reconocida
            ? `El nombre «${cabecera}» coincide con este campo.`
            : `No reconocemos «${cabecera}»: dinos tú qué es.`,
        };
      }),
      ivaPista: { valor: 'no_se', motivo: 'En la demostración no se analiza el archivo.' },
      avisos: [
        'Estás en la demostración: la propuesta se hace por el nombre de las columnas, sin analizar el archivo.',
      ],
    };
  },

  async chatWithAssistant(input: AssistantChatRequest): Promise<AssistantChatResponse> {
    const last = [...input.messages].reverse().find((m) => m.role === 'user');
    if (!last || last.content.trim() === '') {
      throw new ApiError('VALIDATION_ERROR', 'Escribe una pregunta para Alexia.', 400);
    }
    await pause(500);
    // Desde el panel de ayuda: si la pregunta se parece a una FAQ de la
    // pantalla, se contesta con ella. En la demo no hay modelo detras y una
    // pregunta de «como hago X» no puede acabar en una cifra cualquiera.
    const faq = input.screen ? faqParecida(input.screen, last.content) : null;
    if (faq) return { reply: faq, toolCalls: [] };
    return demoChat(assistantData(), last.content, input.period, todayIso());
  },

  /* --- Facturacion --- */

  async changePlan(plan: 'basic' | 'pro', interval?: BillingInterval) {
    // En la demo el cambio es inmediato: es el escaparate del flujo. El
    // periodo se conserva si no se indica, como en la API.
    state.tenant = {
      ...state.tenant,
      plan,
      subscriptionStatus: 'active',
      billingInterval: interval ?? state.tenant.billingInterval ?? 'month',
    };
    return { ok: true as const };
  },

  async contractAddon(_addon: 'escaner') {
    // Como la API (15 oct 2026): el módulo ya no se vende, va incluido.
    throw new ApiError(
      'VALIDATION_ERROR',
      'El escáner ya va incluido en todos los planes. Si necesitas más, compra 150 escaneos desde Configuración → Tu plan (solo para ese mes) o agrega un local extra.',
      400,
    );
  },

  async startScanPackCheckout(): Promise<{ url: string }> {
    // Las mismas reglas que la API; el pago, como todos, no existe en la demo.
    if (!puedeComprarEscaneos(state.tenant)) {
      throw new ApiError(
        'VALIDATION_ERROR',
        state.tenant.plan === 'trial'
          ? 'Durante la prueba no se compran escaneos: elige un plan para seguir escaneando.'
          : 'Los escaneos extra se compran con un plan activo. Elige Básico o Pro desde Configuración.',
        400,
      );
    }
    throw new ApiError('FORBIDDEN', 'La compra de escaneos no está disponible en el modo de demostración.', 403);
  },

  async cancelAddon(addon: 'escaner') {
    state.tenant = {
      ...state.tenant,
      addons: (state.tenant.addons ?? []).filter((a) => a !== addon),
    };
    return { ok: true as const };
  },

  /* En la demo hay dos facturas de ejemplo para que se vea la pantalla; el PDF
     no existe y la interfaz lo dice en vez de descargar un fichero vacio. */
  async getInvoices() {
    const hoy = todayIso();
    const mesPasado = addDaysIso(hoy, -30);
    return [
      { id: 'demo-2', numero: 'AR26/0002', fecha: hoy, baseCents: 4900, totalCents: 5929 },
      { id: 'demo-1', numero: 'AR26/0001', fecha: mesPasado, baseCents: 4900, totalCents: 5929 },
    ];
  },

  async getInvoicePdfUrl(): Promise<string> {
    throw new Error('En modo demostración las facturas son de ejemplo y no tienen PDF.');
  },

  async startCheckout(_plan: 'basic' | 'pro', _interval?: BillingInterval, extra?: { tax?: TaxProfile }): Promise<{ url: string }> {
    // Como la API (sección 18): los datos de la factura de «Elige tu plan» se
    // validan y se guardan antes de abrir el pago. El pago, en la demo, no existe.
    const tax = Object.fromEntries(Object.entries(extra?.tax ?? {}).filter(([, v]) => typeof v === 'string' && v.trim() !== '')) as TaxProfile;
    if (Object.keys(tax).length) {
      const merged: TaxProfile = { ...state.tenant.tax, ...tax };
      if (merged.taxId) {
        const veredicto = validarTaxId(merged.taxId, merged.taxCountry ?? state.tenant.country);
        if (!veredicto.ok) throw new ApiError('VALIDATION_ERROR', veredicto.message ?? 'Revisa la identificación fiscal.', 400);
        merged.taxId = normalizarTaxId(merged.taxId);
      }
      state.tenant = { ...state.tenant, tax: merged };
    }
    throw new ApiError(
      'FORBIDDEN',
      'La suscripción no está disponible en el modo de demostración.',
      403,
    );
  },

  /** Espejo de GET /v1/tenants/current/trial-summary (api/src/finPrueba.ts). */
  async getTrialSummary(): Promise<ResumenPrueba> {
    return resumenDePruebaDemo();
  },

  async startFounderCheckout(_code: string): Promise<{ url: string }> {
    throw new ApiError(
      'FORBIDDEN',
      'La suscripción Founder no está disponible en el modo de demostración.',
      403,
    );
  },

  async saveCancellationFeedback(reason) {
    state.tenant.cancellationFeedback = { reason, createdAt: new Date().toISOString() };
    return { ok: true };
  },
  async openBillingPortal(): Promise<{ url: string }> {
    throw new ApiError(
      'FORBIDDEN',
      'El portal de facturación no está disponible en el modo de demostración.',
      403,
    );
  },

  /* --- Retención al darse de baja (espejo de api/src/retencionBaja.ts) --- */

  async startRetention() {
    const ahora = new Date();
    const ultima = demoOfertasDeRetencion.at(-1);
    const sinOfertaPor = sinOfertaDeRetencionPor(state.tenant, { ultimaOfertaAt: ultima?.fecha }, ahora.getTime());
    const flujoId = `${ahora.toISOString()}#demo${demoOfertasDeRetencion.length}`;
    state.tenant = { ...state.tenant, retencionBaja: conFlujoDeRetencion(state.tenant.retencionBaja, { id: flujoId, abiertoAt: ahora.toISOString(), ...(sinOfertaPor ? { sinOfertaPor } : {}) }) };
    return { flujoId, periodoHasta: finDePeriodoDemo(), anual: state.tenant.billingInterval === 'year', sinOfertaPor };
  },

  async chooseRetentionReason({ flujoId, reason, comment }) {
    const ahora = new Date();
    const flujo = state.tenant.retencionBaja?.find((f) => f.id === flujoId);
    if (!flujo) throw new ApiError('VALIDATION_ERROR', 'Vuelve a abrir «Cancelar mi plan» y empieza otra vez.', 400);
    state.tenant = { ...state.tenant, cancellationFeedback: { reason, createdAt: ahora.toISOString(), ...(comment?.trim() ? { comment: comment.trim() } : {}) } };
    const tipo = ofertaParaMotivo(reason);
    const yaEnEsteFlujo = demoOfertasDeRetencion.some((o) => o.flujoId === flujoId);
    const por = yaEnEsteFlujo ? 'ya_tuvo_oferta' as const : tipo ? sinOfertaDeRetencionPor(state.tenant, { ultimaOfertaAt: demoOfertasDeRetencion.at(-1)?.fecha }, ahora.getTime()) : null;
    if (!tipo || por) {
      state.tenant = { ...state.tenant, retencionBaja: conFlujoDeRetencion(state.tenant.retencionBaja, { ...flujo, motivo: reason, oferta: null, ...(por ? { sinOfertaPor: por } : {}) }) };
      return { oferta: null, sinOfertaPor: por };
    }
    demoOfertasDeRetencion.push({ flujoId, fecha: ahora.toISOString(), oferta: tipo, aceptada: false });
    state.tenant = { ...state.tenant, retencionBaja: conFlujoDeRetencion(state.tenant.retencionBaja, { ...flujo, motivo: reason, oferta: tipo }) };
    const sinPausa = { ...state.tenant, pausedFrom: undefined, pausedUntil: undefined };
    const precios = { actual: mrrDeTenant(sinPausa), basico: mrrDeTenant({ ...sinPausa, plan: 'basic' }) };
    return { oferta: vistaDeOfertaDeRetencion(tipo, state.tenant, precios, finDePeriodoDemo(), ahora.getTime()), sinOfertaPor: null };
  },

  async acceptRetentionOffer({ flujoId, aceptada, meses, falta }) {
    const ahora = new Date();
    const registro = demoOfertasDeRetencion.find((o) => o.flujoId === flujoId);
    const flujo = state.tenant.retencionBaja?.find((f) => f.id === flujoId);
    if (!registro || !flujo || !ofertaReciente(registro.fecha, ahora.getTime())) throw new ApiError('VALIDATION_ERROR', 'Esta oferta ya no está disponible.', 400);
    if (registro.aceptada) throw new ApiError('VALIDATION_ERROR', 'Ya aceptaste esta oferta.', 400);
    if (!aceptacionesDe(registro.oferta, state.tenant.plan).includes(aceptada)) throw new ApiError('VALIDATION_ERROR', 'Esa opción no va con esta oferta.', 400);
    registro.aceptada = true;
    let pausa: { pausedFrom: string; pausedUntil: string } | undefined;
    if (aceptada === 'pausa') {
      const desde = finDePeriodoDemo();
      pausa = { pausedFrom: desde, pausedUntil: finDePausa(desde, meses ?? 1) };
    }
    state.tenant = {
      ...state.tenant,
      ...(aceptada === 'basico' ? { plan: 'basic' as const } : {}),
      ...(pausa ?? {}),
      ...(falta?.trim() && state.tenant.cancellationFeedback ? { cancellationFeedback: { ...state.tenant.cancellationFeedback, missing: falta.trim() } } : {}),
      retencionBaja: conFlujoDeRetencion(state.tenant.retencionBaja, { ...flujo, aceptada, aceptadaAt: ahora.toISOString(), ...(aceptada === 'pausa' ? { mesesDePausa: meses ?? 1 } : {}) }),
    };
    return { ok: true as const, aceptada, ...(pausa ?? {}) };
  },

  async declineRetentionOffer({ flujoId, falta }) {
    const flujo = state.tenant.retencionBaja?.find((f) => f.id === flujoId);
    if (flujo) {
      state.tenant = {
        ...state.tenant,
        ...(falta?.trim() && state.tenant.cancellationFeedback ? { cancellationFeedback: { ...state.tenant.cancellationFeedback, missing: falta.trim() } } : {}),
        retencionBaja: conFlujoDeRetencion(state.tenant.retencionBaja, { ...flujo, rechazadaAt: new Date().toISOString() }),
      };
    }
    return { ok: true as const };
  },

  async openCancelPortal(flujoId?: string): Promise<{ url: string }> {
    const flujo = flujoId ? state.tenant.retencionBaja?.find((f) => f.id === flujoId) : undefined;
    if (flujo) state.tenant = { ...state.tenant, retencionBaja: conFlujoDeRetencion(state.tenant.retencionBaja, { ...flujo, aPortalAt: new Date().toISOString() }) };
    throw new ApiError('FORBIDDEN', 'En la demo no hay pagos de verdad: aquí se abriría Stripe para cancelar tu plan.', 403);
  },

  async resumePlan() {
    if (!state.tenant.pausedUntil && !state.tenant.pausedFrom) throw new ApiError('VALIDATION_ERROR', 'Tu plan no está en pausa.', 400);
    state.tenant = { ...state.tenant, pausedFrom: undefined, pausedUntil: undefined };
    return { ok: true as const };
  },

  async setExtraSeats(): Promise<{ ok: true }> {
    throw new ApiError(
      'FORBIDDEN',
      'Los usuarios adicionales no están disponibles en el modo de demostración.',
      403,
    );
  },

  async setExtraLocations(): Promise<{ ok: true }> {
    throw new ApiError(
      'FORBIDDEN',
      'Los centros extra no están disponibles en el modo de demostración.',
      403,
    );
  },

  /* --- Equipo --- */

  async getTeam(): Promise<TeamResponse> {
    return {
      memberships: [state.user],
      // Como la API: el límite es el del plan (antes decía 5 en prueba: «1 de 5» e «incluye 1»).
      seats: { used: 1, limit: seatLimitFor(state.tenant.plan, state.tenant.extraSeats ?? 0), extraSeats: state.tenant.extraSeats ?? 0, extraSeatPrice: 5 },
    };
  },

  async inviteMember(): Promise<never> {
    throw new ApiError(
      'FORBIDDEN',
      'En la demo no se puede invitar a nadie. Crea tu cuenta para montar tu equipo.',
      403,
    );
  },

  async changeMemberRole(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'En la demo no se puede gestionar el equipo.', 403);
  },

  /*
   * Los roles personalizados SI funcionan en la demo: es una pantalla que se
   * entiende tocandola, y montar uno no toca a nadie porque en la demo el
   * equipo es una sola persona.
   */
  async listCustomRoles(): Promise<{ roles: CustomRole[] }> {
    return {
      roles: clone([
        ...PREDEFINED_ROLES.map((role) => ({ ...role, tenantId: TENANT_ID })),
        ...state.customRoles,
      ]),
    };
  },

  async createCustomRole(input: CustomRoleInput): Promise<{ role: CustomRole }> {
    if (state.customRoles.some((r) => r.name.toLowerCase() === input.name.toLowerCase())) {
      throw new ApiError('VALIDATION_ERROR', 'Ya tienes un rol con ese nombre.', 400);
    }
    const role: CustomRole = {
      tenantId: TENANT_ID,
      roleId: `rol-${state.customRoles.length + 1}-${Date.now()}`,
      name: input.name,
      permissions: input.permissions,
      createdAt: new Date().toISOString(),
    };
    state.customRoles = [...state.customRoles, role];
    return { role: clone(role) };
  },

  async updateCustomRole(roleId: string, input: CustomRoleInput): Promise<{ role: CustomRole }> {
    if (roleId.startsWith('preset:')) {
      throw new ApiError('VALIDATION_ERROR', 'Los roles predefinidos de Alexia no se pueden modificar.', 400);
    }
    const actual = state.customRoles.find((r) => r.roleId === roleId);
    if (!actual) throw new ApiError('NOT_FOUND', 'Ese rol no existe.', 404);
    const role: CustomRole = {
      ...actual,
      name: input.name,
      permissions: input.permissions,
      updatedAt: new Date().toISOString(),
    };
    state.customRoles = state.customRoles.map((r) => (r.roleId === roleId ? role : r));
    return { role: clone(role) };
  },

  async deleteCustomRole(roleId: string): Promise<{ ok: true }> {
    if (roleId.startsWith('preset:')) {
      throw new ApiError('VALIDATION_ERROR', 'Los roles predefinidos de Alexia no se pueden borrar.', 400);
    }
    state.customRoles = state.customRoles.filter((r) => r.roleId !== roleId);
    return { ok: true };
  },

  async deactivateMember(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'En la demo no se puede gestionar el equipo.', 403);
  },

  async activateMember(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'En la demo no se puede gestionar el equipo.', 403);
  },

  async resendInvitation(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'En la demo no se puede gestionar el equipo.', 403);
  },

  /* --- Importacion masiva del catalogo --- */

  async importIngredients(batch: IngredientBatch): Promise<BatchResult> {
    const result: BatchResult = { creados: 0, actualizados: 0, errores: [] };
    for (const nombre of batch.suppliers ?? []) {
      const existe = state.suppliers.some(
        (s) => s.name.trim().toLowerCase() === nombre.trim().toLowerCase(),
      );
      if (!existe) {
        state.suppliers = [
          ...state.suppliers,
          { tenantId: TENANT_ID, supplierId: newId('sup'), name: nombre.trim() },
        ];
      }
    }
    for (const [index, item] of batch.items.entries()) {
      const proveedor = item.supplierName
        ? state.suppliers.find(
            (s) => s.name.trim().toLowerCase() === item.supplierName!.trim().toLowerCase(),
          )
        : undefined;
      const { priceConfirmed: _priceConfirmed, ...fields } = item.input;
      const base = { ...fields, ...(proveedor ? { supplierId: proveedor.supplierId } : {}) };
      const now = new Date().toISOString();
      if (!item.id && base.createdVia === 'factura' && state.ingredients.some(ing => invoiceIngredientKey(ing) === invoiceIngredientKey(base))) {
        result.errores.push({ index, name: base.name, message: 'Este ingrediente y formato ya existen. Selecciónalo para actualizar su precio.' });
        continue;
      }
      if (item.id) {
        state.ingredients = state.ingredients.map((ing) =>
          ing.ingredientId === item.id
            ? { ...ing, ...base, pricePending: base.netPrice == null, priceEstimated: ing.priceEstimated, updatedAt: now,
              priceUpdatedAt: base.netPrice == null ? undefined : now }
            : ing,
        );
        result.actualizados += 1;
      } else {
        state.ingredients = [
          ...state.ingredients,
          {
            ...base,
            tenantId: TENANT_ID,
            pricePending: base.netPrice == null,
            priceEstimated: base.netPrice == null && base.purchaseUnit ? demoPriceEstimate(base.name, base.purchaseUnit, state.tenant.country, state.tenant.currency) ?? undefined : undefined,
            ingredientId: newId('ing'),
            updatedAt: now,
            priceUpdatedAt: base.netPrice != null ? now : undefined,
          } as Ingredient,
        ];
        result.creados += 1;
      }
    }
    await pause(300);
    return result;
  },

  async importRecipes(batch: RecipeBatch): Promise<BatchResult> {
    const result: BatchResult = { creados: 0, actualizados: 0, errores: [] };
    // Dos pasadas, como la API: una receta puede apuntar a otra del mismo
    // fichero, que hasta que no se crea no tiene id.
    const clave = (nombre: string) => nombre.trim().toLowerCase();
    const idPorNombre = new Map(state.recipes.map((r) => [clave(r.name), r.recipeId]));
    const pendientes: Array<{ recipeId: string; input: RecipeImportInput }> = [];

    for (const [index, original] of batch.items.entries()) {
      const item = { ...original, input: { ...original.input, components: original.input.components.map((comp) => {
        if (comp.ref.kind !== 'ingredient_del_fichero') return comp;
        const name = comp.ref.ingredientName;
        const matches = state.ingredients.filter((ing) => clave(ing.name) === clave(name));
        return matches.length === 1 ? { ...comp, ref: { kind: 'ingredient' as const, ingredientId: matches[0].ingredientId } } : comp;
      }) } };
      if (item.input.components.some((comp) => comp.ref.kind === 'ingredient_del_fichero')) {
        result.errores.push({ index, name: item.input.name, message: 'Confirma primero los ingredientes nuevos.' });
        continue;
      }
      const resueltas = item.input.components.filter(
        (comp) => comp.ref.kind !== 'recipe_del_fichero',
      );
      const primera = { ...item.input, components: resueltas };
      const recipeId = item.id ?? newId('rec');

      if (item.id) {
        state.recipes = state.recipes.map((r) =>
          r.recipeId === item.id
            ? ({ ...r, ...primera, updatedAt: new Date().toISOString() } as Recipe)
            : r,
        );
        result.actualizados += 1;
      } else {
        state.recipes = [
          ...state.recipes,
          {
            ...primera,
            tenantId: TENANT_ID,
            recipeId,
            updatedAt: new Date().toISOString(),
          } as unknown as Recipe,
        ];
        result.creados += 1;
      }
      idPorNombre.set(clave(item.input.name), recipeId);
      if (resueltas.length !== item.input.components.length) {
        pendientes.push({ recipeId, input: item.input });
      }
    }

    for (const { recipeId, input } of pendientes) {
      const components = input.components.map((comp) =>
        comp.ref.kind === 'recipe_del_fichero'
          ? { ...comp, ref: { kind: 'recipe' as const, recipeId: idPorNombre.get(clave(comp.ref.recipeName)) ?? '' } }
          : comp,
      );
      state.recipes = state.recipes.map((r) =>
        r.recipeId === recipeId
          ? ({ ...r, ...input, components, updatedAt: new Date().toISOString() } as unknown as Recipe)
          : r,
      );
    }

    await pause(300);
    return result;
  },

  /* --- Panel de plataforma --- */

  /* --- Escaner de facturas --- */

  async getScanQuota() {
    // En la demo el escaner se ensena funcionando: es de las cosas que mas
    // venden y esconderla detras de un "no disponible" seria tirar piedras
    // contra el escaparate. Lo que NO hay es OCR de verdad.
    const q = cuotaDemo();
    return {
      ...q,
      planName: PLANS[state.tenant.plan]?.name ?? state.tenant.plan,
      // Como la API: solo el dueño compra (POST /billing/scan-pack es requireRole('owner')).
      canBuyPack: state.user.role === 'owner' && puedeComprarEscaneos(state.tenant),
      billingCurrency: billingCurrency(state.tenant.country),
      message: q.sinModulo || q.exhausted ? mensajeSinEscaneos() : undefined,
    };
  },

  async createScanUploadUrl(): Promise<never> {
    throw new ApiError(
      'INTERNAL',
      'En la demostración el escáner funciona con una factura de ejemplo: haz clic en «Probar con una factura de ejemplo».',
      501,
    );
  },

  async scanReceipt(key: string, documentType?: PurchaseDocumentType) {
    // 1 escaneo = 1 página, como en la API.
    const paginas: ScannedDocument[] = key === 'demo-2-paginas' ? facturaDemoDosPaginas() : [FACTURA_DEMO];
    exigirEscaneos();
    demoScans += paginas.length;
    const documento = fusionarPaginas(paginas);
    // Como la API: la partida habitual de cada proveedor y SIN el IVA de ventas
    // como tipo por defecto (hinchaba la base de una compra).
    const draft = buildExpenseDraft(documento, {
      suppliers: state.suppliers.map((s) => ({ supplierId: s.supplierId, name: s.name, taxId: s.taxId })),
      categoriaHabitual: categoriasPorProveedor(state.expenses, state.suppliers),
      country: state.tenant.country,
      recientes: state.expenses.slice(-200),
      documentType,
      today: todayIso(),
    });
    // Como la API: el ID fiscal leído se guarda en silencio si el proveedor no lo tenía.
    const taxIdLeido = taxIdComparable(draft.supplierTaxId);
    if (draft.supplierId && taxIdLeido && taxIdLeido.length >= 6) {
      state.suppliers = state.suppliers.map((s) => (s.supplierId === draft.supplierId && !s.taxId ? { ...s, taxId: taxIdLeido } : s));
    }
    const id = newId('draft');
    const now = new Date();
    // Como la API (bloque S): sin tipo dicho, una nota sin datos fiscales es una nota;
    // los dos borradores llevan la clave del archivo (una fila en «Por revisar») y esperan 60 días.
    const tipo = documentType ?? (draft.esNota ? 'albaran' as const : undefined);
    const inputKey = `demo/escaneo-${id}`;
    const vence = Math.floor(now.getTime() / 1000) + DEMO_SCAN_TTL_SECONDS;
    drafts.push({ id, tenantId: TENANT_ID, kind: 'expense', source: 'demo', status: 'pending', inputKey, payload: { proposal: draft, documentType: tipo, requiresReview: draft.avisos.length > 0 }, summary: draft.concept, createdBy: { userSub: state.user.userId }, createdAt: now.toISOString(), expiresAt: vence });
    const catalogDraftId = newId('draft');
    // Igual que la API (fase 7): alias del proveedor y «No es un ingrediente» recordado.
    // Solo una compra de materia prima propone precios de ingredientes.
    const catalogPrices = invoiceLinesToCatalogProposal(conPreciosDeCatalogo(draft.category) ? documento.lines ?? [] : [], state.ingredients, { supplierId: draft.supplierId, noIngredientRules });
    const hayPrecios = catalogPrices.lines.some((line) => line.action !== 'ignore');
    if (hayPrecios) drafts.push({ id: catalogDraftId, tenantId: TENANT_ID, kind: 'catalog-prices', source: 'demo', status: 'pending', inputKey, payload: catalogPrices, summary: 'Precios de la factura por revisar', createdBy: { userSub: state.user.userId }, createdAt: now.toISOString(), expiresAt: vence });
    return {
      draftId: id, catalogDraftId: hayPrecios ? catalogDraftId : undefined, documentType: tipo,
      key: paginas.length > 1 ? 'demo/factura-2-paginas.pdf' : 'demo/factura-ejemplo.jpg',
      draft,
      catalogPrices,
      quota: cuotaDemo(),
    };
  },

  /**
   * Hoja de recuento de ejemplo: las filas que devolveria el OCR de una hoja
   * impresa desde esta misma demo y rellenada a mano. Recorre el MISMO
   * emparejador que la app real: si se rompiera, se romperia aqui.
   */
  async scanCorte(): Promise<RevenueFill> {
    // Sin OCR en la demo: el corte de ejemplo del diseño (con IVA).
    exigirEscaneos();
    demoScans += 1;
    const app = state.settings.platforms.find((p) => p.active);
    return {
      fields: {
        efectivo: 1120, tarjeta: 1745.5, takeaway: 186.5, takeawayOrders: 9,
        ...(app ? { delivery: { [app.platformId]: 429.48 }, platformOrders: { [app.platformId]: 12 } } : {}),
        customers: 168, tables: 64,
      },
      hints: [],
    };
  },

  async fillRevenueForm(text: string): Promise<RevenueFill> {
    // Sin IA en la demo: un lector de cifras escritas con número.
    const t = text.toLowerCase();
    const cifra = (s: string) => Number(s.replace(/[.,]$/, '').replace(/,(?=\d{3}\b)/g, '').replace(',', '.'));
    const antes = (word: string) => { const m = t.match(new RegExp(`${word}\\D{0,12}?(\\d[\\d.,]*)`)); return m ? cifra(m[1]) : undefined; };
    const cuenta = (word: string) => { const m = t.match(new RegExp(`(\\d+)\\s*${word}`)); return m ? Number(m[1]) : undefined; };
    const fields: RevenueFill['fields'] = {};
    const put = <K extends keyof RevenueFill['fields']>(k: K, v: RevenueFill['fields'][K] | undefined) => { if (v !== undefined && !Number.isNaN(v as number)) fields[k] = v; };
    put('efectivo', antes('efectivo'));
    put('tarjeta', antes('tarjeta'));
    put('takeaway', antes('para llevar'));
    put('customers', cuenta('clientes'));
    put('tables', cuenta('mesas'));
    for (const p of state.settings.platforms.filter((x) => x.active)) {
      const v = antes(p.name.toLowerCase().split(' ')[0]);
      if (v !== undefined) fields.delivery = { ...(fields.delivery ?? {}), [p.platformId]: v };
    }
    return { fields, hints: [] };
  },

  async scanInventorySheet(): Promise<InventoryScanResult> {
    exigirEscaneos();
    demoScans += 1;
    const ings = [...state.ingredients].filter((i) => i.active).slice(0, 9);
    const cantidades = ['2,5', '4', '1/2', '12', '', '3', '0,75', '6', '1'];
    const hoja = {
      rows: [
        { cells: ['Ingrediente', 'Formato de compra', 'Cantidad contada'], confidence: 99 },
        ...ings.map((ing, i) => ({
          cells: [ingredientDisplayName(ing), purchaseFormatLabel(ing), cantidades[i] ?? ''],
          confidence: i === 2 ? 71 : 96,
        })),
        { cells: ['Sal gorda (no está en Alexia)', 'Saco de 5 kg', '2'], confidence: 90 },
      ],
    };
    return {
      key: 'demo/hoja-recuento-ejemplo.jpg',
      draft: buildInventoryDraft(hoja, state.ingredients),
      quota: cuotaDemo(),
    };
  },

  async getReceiptUrl(): Promise<never> {
    throw new ApiError(
      'INTERNAL',
      'En la demostración no se guardan documentos: los gastos de ejemplo no tienen factura adjunta.',
      501,
    );
  },

  async adminChangePlan(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'No disponible en la demostración.', 403);
  },

  async adminRetryHolded(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'El panel de administración no está en la demo.', 403);
  },

  async adminEnviarResumenSemanal(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'El panel de administración no está en la demo.', 403);
  },
  async adminCampanaNovedades(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'El panel de administración no está en la demo.', 403);
  },
  async adminPruebaNovedades(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'El panel de administración no está en la demo.', 403);
  },
  async adminEnviarNovedades(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'El panel de administración no está en la demo.', 403);
  },

  async adminMarkAssistedOnboarding(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'El panel de administración no está en la demo.', 403);
  },
  async adminSetCortesia(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'El panel de administración no está en la demo.', 403);
  },
  async adminSetInternal(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'El panel de administración no está en la demo.', 403);
  },
  async adminSetBonusLocations(_tenantId: string, bonusLocations: number) {
    return { ok: true as const, bonusLocations };
  },
  async adminApplyCoupon(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'No disponible en la demostración.', 403);
  },

  async getAdminOverview(): Promise<AdminOverview> {
    // Existe solo para cumplir el contrato: en la demo nunca se llega aqui
    // (getMe no marca platformAdmin y la ruta /admin esta protegida).
    throw new ApiError(
      'FORBIDDEN',
      'El panel de administración no está disponible en el modo de demostración.',
      403,
    );
  },

  async getPlatformPnl(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'No disponible en la demostración.', 403);
  },

  async createPlatformRecurring(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'El panel de administración no está en la demo.', 403);
  },
  async deletePlatformRecurring(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'El panel de administración no está en la demo.', 403);
  },
  async setPlatformSettings(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'El panel de administración no está en la demo.', 403);
  },
  async setPlatformSettlement(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'El panel de administración no está en la demo.', 403);
  },
  async createPlatformExpense(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'No disponible en la demostración.', 403);
  },

  async deletePlatformExpense(): Promise<never> {
    throw new ApiError('FORBIDDEN', 'No disponible en la demostración.', 403);
  },
};

/**
 * Prueba terminada sin plan (sección 18, 15 oct 2026), espejo de `impagoGuard`
 * de la API: se lee todo y se descarga en Excel, pero no se suma nada. Siguen
 * abiertos elegir plan, borrar la cuenta, el perfil, las preferencias y la
 * Configuración básica (`permitidaSinPlan` en api/src/auth.ts).
 */
const ABIERTAS_SIN_PLAN = /^(list|get|export|admin|welcome|weekly|trialExtension|acceptTrialExtension|startCheckout|startFounderCheckout|startScanPackCheckout|changePlan|openBillingPortal|saveCancellationFeedback|startRetention|chooseRetentionReason|acceptRetentionOffer|declineRetentionOffer|openCancelPortal|resumePlan|updateTenant|updateSettings|updateMy|markTour|markAviso|markWelcome|requestAccountDeletion|cancelAccountDeletion|fillMissingTimezone|setWelcome|setWeekly|savePushSubscription|setExtraSeats|setExtraLocations)/;
export const demoApi: AlexiaRestApi = new Proxy(demoApiSinCerrojo, {
  get(target, prop, receiver) {
    const valor = Reflect.get(target, prop, receiver);
    if (typeof valor !== 'function' || typeof prop !== 'string' || ABIERTAS_SIN_PLAN.test(prop)) return valor;
    return (...args: unknown[]) => {
      // Prueba terminada sin plan o plan cancelado (`sinPlanActivo`), como la API.
      if (sinPlanActivo(state.tenant)) return Promise.reject(new ApiError('PLAN_LIMIT', mensajeSinPlan(state.tenant), 402));
      return (valor as (...a: unknown[]) => unknown).apply(target, args);
    };
  },
});

// `?prueba=10|14|terminada`: para ver (y probar en los smokes) el fin de la
// prueba: el aviso del día 10, el último día y la cuenta sin plan.
if (typeof window !== 'undefined') {
  const prueba = new URLSearchParams(window.location.search).get('prueba');
  const dias = prueba === '10' ? 4 : prueba === '14' ? 1 : prueba === 'terminada' ? -4 : null;
  // Días del calendario del restaurante (como `fasePrueba`): con la fecha UTC,
  // en CDMX por la tarde «?prueba=14» ya no caía en el último día.
  const fin = (n: number) => {
    const d = new Date(`${fechaEnZona(Date.now(), zonaDeLaPrueba(state.tenant))}T00:00:00Z`);
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
  };
  if (dias !== null) state.tenant = { ...state.tenant, trialEndsAt: fin(dias), createdAt: new Date(Date.parse(fin(dias)) - TRIAL_DAYS * 86_400_000).toISOString() };
  // `?prueba=cancelada`: se dio de baja (plan cancelado), como deja la cuenta `subscription.deleted`.
  if (prueba === 'cancelada') state.tenant = { ...state.tenant, plan: 'trial', subscriptionStatus: 'canceled', firstPaidAt: enDias(-60) };
}

// `?locales=3`: al final del módulo, cuando ya existen todos los `let` del estado.
if (typeof window !== 'undefined') {
  const cuantos = Number(new URLSearchParams(window.location.search).get('locales'));
  if (cuantos >= 2 && cuantos <= 4) sembrarLocalesDemo(cuantos);
}

// `?plan=basic&gastados=150`: para ver (y probar en los smokes) una cuenta que
// ya paga, con los escaneos del mes gastados. Sin parámetros, la demo es una prueba.
if (typeof window !== 'undefined') {
  const params = new URLSearchParams(window.location.search);
  const plan = params.get('plan');
  if (plan === 'basic' || plan === 'pro' || plan === 'founder') {
    // `&periodo=anual`: el plan anual (retención: sin ofertas, «no renovar»).
    state.tenant = { ...state.tenant, plan, subscriptionStatus: 'active', billingInterval: params.get('periodo') === 'anual' ? 'year' : 'month', stripeSubscriptionId: 'sub_demo' };
  }
  // `&pausa=activa|programada`: el plan en pausa ya (solo lectura) o a partir del fin del periodo.
  const pausa = params.get('pausa');
  if (pausa === 'activa') state.tenant = { ...state.tenant, pausedFrom: enDias(-3), pausedUntil: new Date(Date.now() + 28 * 86_400_000).toISOString() };
  if (pausa === 'programada') state.tenant = { ...state.tenant, pausedFrom: finDePeriodoDemo(), pausedUntil: finDePausa(finDePeriodoDemo(), 1) };
  const gastados = Number(params.get('gastados'));
  if (Number.isInteger(gastados) && gastados > 0 && gastados <= 1000) demoScans = gastados;
}
